import React, { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";
import styles from "../../form.module.css";
import {
  Button,
  Checkbox,
  Col,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Typography,
  DatePicker,
  Table,
  Image,
} from "antd";
import { CopyOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import useFetch from "../../../../hooks/useFetch";
import useToast from "../../../../hooks/useToast";
import {
  eFORMSTATUS,
  eResultCode,
  eSTAGE,
  eYES_OR_NO,
  eUSER_FORM_TYPE,
  INPUT_LENGTH,
} from "../../../../utils/enum";
import { ToastOpen, ToastType } from "../../../../state/toast/slice";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Text, { LanguageContext } from "../../../../context/language-context";
import { FaCheck } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserContext } from "../../../../context";
import { GetFormData, updateField } from "../../../../utils/api.constant";
import { TFormProps } from "../../../../types";
import { LoaderContext } from "../../../../context/loader";
import EncryptUtils from "../../../../utils/encrypt";
import Utils from "../../../../utils";
import {
  allowOnlyNumericInput_onKeyDown,
  disableFutureDates_on_input_date_max,
  disableFutureDates_on_input_month_max,
  numberInputRules,
  validateFile,
} from "../../../../utils/input.validator";
import {
  DocumentUploadTableField,
  DocumentUploadField,
} from "../../../../components/document-upload";
import { CURRENT_YEAR, EXAM_INSTITUTE_LIST } from "../../../../utils/constants";
import { Rule } from "antd/es/form";
import { useFormAutoSave } from "../../../../hooks/useFormAutoSave";
import { eAnswerType } from "../../../../utils/enum";
import { FilePdfOutlined } from "@ant-design/icons";
import { TableProps } from "antd";
import { getNumberInLanguage } from "../../../../utils/helperFunctions";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StudentPartTwo = ({
  disabled = false,
  currentFormId,
  currentUserId,
  currentFormFor,
}: TFormProps) => {
  const [form] = Form.useForm();
  const contextForLoader = useContext(LoaderContext);
  const { isLoading, setIsLoading } = contextForLoader as any;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { post } = useFetch();
  const { onShowToast } = useToast();
  const navigate = useNavigate();
  const [formId, setFormId] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | number | null>(null);
  const [formFor, setFormFor] = useState<string | null>(null);
  const { user } = useContext(UserContext);
  const { dictionary } = useContext(LanguageContext);
  const [documentsData, setDocumentsData] = useState<any>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isReviewMode, setIsReviewMode] = useState(false);

  const [applyPdfStyles, setApplyPdfStyles] = useState(false);

  // Watch affidavitAccepted to trigger re-renders when checkbox changes
  const affidavitAccepted = Form.useWatch("affidavitAccepted", form);

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {isLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const DROPDOWN_PLACEHOLDER = Text({
    tid: "DROPDOWN_PLACEHOLDER",
    def: "DROPDOWN_PLACEHOLDER",
  });
  const STUDENT_2026_PT2_Q4_C_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q4_C_PLACEHOLDER",
    def: "Ex. Salakshana Ghananta",
  });
  const STUDENT_2026_PT2_Q5_C_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q5_C_PLACEHOLDER",
    def: "Ex. Pandit Ramprasad Bismil",
  });
  const STUDENT_2026_PT2_Q5_D_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q5_D_PLACEHOLDER",
    def: "Ex. Mama Shree",
  });
  const STUDENT_2026_PT2_Q5_E_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q5_E_PLACEHOLDER",
    def: "Ex. Shri Shankaracharya University",
  });
  const STUDENT_2026_PT2_Q6_A_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q6_A_PLACEHOLDER",
    def: "Ex. Yoga Sutra",
  });
  const STUDENT_2026_PT2_Q6_B_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q6_B_PLACEHOLDER",
    def: "Ex. A commentary on Yoga Sutra by Swami Vivekananda",
  });
  const STUDENT_2026_PT2_Q7_B_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q7_B_PLACEHOLDER",
    def: "Ex. Vedanta, Yoga, Nyaya, Vaisheshika, Mimamsa, Samkhya",
  });
  const STUDENT_2026_PT2_Q7_C_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q7_C_PLACEHOLDER",
    def: "Ex. Salakshana Ghananta",
  });
  const STUDENT_2026_PT2_Q8_A_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q8_A_PLACEHOLDER",
    def: "Ex. Vedic recitation program / Sanskrit workshop",
  });
  const STUDENT_2026_PT2_Q8_B_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q8_B_PLACEHOLDER",
    def: "Ex. Indian Vedic Council / Sanskrit University",
  });
  const STUDENT_2026_PT2_Q8_C_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q8_C_PLACEHOLDER",
    def: "Ex. Delhi / Varanasi",
  });
  const PLACE_PLACEHOLDER = Text({
    tid: "PLACE_PLACEHOLDER",
    def: "Ex. : ",
  });

  const BROTHER = Text({ tid: "BROTHER", def: "Brother" });
  const SISTER = Text({ tid: "SISTER", def: "Sister" });

  const STUDENT_PT2_Q3 = Text({ tid: "STUDENT_2026_PT2_Q3", def: " " });
  const STUDENT_PT2_Q3_CONFIRMATION = Text({
    tid: "STUDENT_2026_PT2_Q3_CONFIRMATION",
    def: " ",
  });

  const STUDENT_PT2_Q3_A = Text({ tid: "STUDENT_2026_PT2_Q3_A", def: " " });
  const STUDENT_PT2_Q3_B = Text({ tid: "STUDENT_2026_PT2_Q3_B", def: " " });
  const STUDENT_PT2_Q3_C = Text({ tid: "STUDENT_2026_PT2_Q3_C", def: " " });
  const STUDENT_PT2_Q3_D = Text({ tid: "STUDENT_2026_PT2_Q3_D", def: " " });
  const STUDENT_PT2_Q3_E = Text({ tid: "STUDENT_2026_PT2_Q3_E", def: " " });

  const STUDENT_2026_PT2_Q4_A = Text({
    tid: "STUDENT_2026_PT2_Q4_A",
    def: "अध्ययन प्रारम्भ (माह / वर्ष) :",
  });
  const STUDENT_2026_PT2_Q4_B = Text({
    tid: "STUDENT_2026_PT2_Q4_B",
    def: "अध्ययन सम्पन्न (माह / वर्ष) :",
  });
  const STUDENT_2026_PT2_Q4_C = Text({
    tid: "STUDENT_2026_PT2_Q4_C",
    def: "उत्तीर्ण परीक्षा नाम:",
  });
  const STUDENT_2026_PT2_Q4_D = Text({
    tid: "STUDENT_2026_PT2_Q4_D",
    def: "परीक्षा (माह / वर्ष) : ",
  });
  const STUDENT_2026_PT2_Q4_E = Text({
    tid: "STUDENT_2026_PT2_Q4_E",
    def: "परीक्षा संस्थान :",
  });
  const STUDENT_2026_PT2_Q4_F = Text({
    tid: "STUDENT_2026_PT2_Q4_F",
    def: "उत्तीर्ण श्रेणी :",
  });
  const STUDENT_2026_PT2_Q4_G = Text({
    tid: "STUDENT_2026_PT2_Q4_G",
    def: "उत्तीर्ण परीक्षा का प्रमाणपत्र / अंकतालिका यहां अपलोड करे :",
  });

  const STUDENT_2026_PT2_Q5_A = Text({
    tid: "STUDENT_2026_PT2_Q5_A",
    def: "अध्ययन प्रारम्भ (माह/वर्ष)",
  });
  const STUDENT_2026_PT2_Q5_B = Text({
    tid: "STUDENT_2026_PT2_Q5_B",
    def: "अध्ययन सम्पन्न (माह/वर्ष)",
  });
  const STUDENT_2026_PT2_Q5_C = Text({
    tid: "STUDENT_2026_PT2_Q5_C",
    def: "उत्तीर्ण परीक्षा का नाम",
  });
  const STUDENT_2026_PT2_Q5_D = Text({
    tid: "STUDENT_2026_PT2_Q5_D",
    def: "परीक्षा (माह/वर्ष)",
  });

  const STUDENT_2026_PT2_Q5_E = Text({
    tid: "STUDENT_2026_PT2_Q5_E",
    def: "परीक्षा संस्थान",
  });

  const STUDENT_2026_PT2_Q6_A = Text({
    tid: "STUDENT_2026_PT2_Q6_A",
    def: "ग्रन्थ का नाम ",
  });
  const STUDENT_2026_PT2_Q6_B = Text({
    tid: "STUDENT_2026_PT2_Q6_B",
    def: "अध्ययन विवरण ",
  });
  const STUDENT_2026_PT2_Q6_C = Text({
    tid: "STUDENT_2026_PT2_Q6_C",
    def: "अध्ययन प्रारम्भ (माह/वर्ष)",
  });
  const STUDENT_2026_PT2_Q6_D = Text({
    tid: "STUDENT_2026_PT2_Q6_D",
    def: "अध्ययन सम्पन्न (माह/वर्ष)",
  });
  const STUDENT_2026_PT2_Q6_F = Text({
    tid: "STUDENT_2026_PT2_Q6_F",
    def: "अभिलेख अपलोड करे :",
  });

  const STUDENT_2026_PT2_Q6_E = Text({
    tid: "STUDENT_2026_PT2_Q6_E",
    def: "",
  });

  const STUDENT_2026_PT2_Q7 = Text({ tid: "STUDENT_2026_PT2_Q7", def: " " });
  const STUDENT_2026_PT2_Q7_A = Text({
    tid: "STUDENT_2026_PT2_Q7_A",
    def: " ",
  });
  const STUDENT_2026_PT2_Q7_B = Text({
    tid: "STUDENT_2026_PT2_Q7_B",
    def: " ",
  });
  const STUDENT_2026_PT2_Q7_C = Text({
    tid: "STUDENT_2026_PT2_Q7_C",
    def: " ",
  });
  const STUDENT_2026_PT2_Q7_D = Text({
    tid: "STUDENT_2026_PT2_Q7_D",
    def: " ",
  });

  const STUDENT_2026_PT2_Q8 = Text({ tid: "STUDENT_2026_PT2_Q8", def: " " });
  const STUDENT_2026_PT2_Q8_A = Text({
    tid: "STUDENT_2026_PT2_Q8_A",
    def: " ",
  });
  const STUDENT_2026_PT2_Q8_B = Text({
    tid: "STUDENT_2026_PT2_Q8_B",
    def: " ",
  });
  const STUDENT_2026_PT2_Q8_C = Text({
    tid: "STUDENT_2026_PT2_Q8_C",
    def: " ",
  });
  const STUDENT_2026_PT2_Q8_D = Text({
    tid: "STUDENT_2026_PT2_Q8_D",
    def: " ",
  });
  const certificateLabel = Text({
    tid: "STUDENT_2026_CERTIFICATE",
    def: "Certificate",
  });

  const ATTACHED_DOC =
    Text({
      tid: "ATTACHED_DOCUMENT",
      def: "Attached Document",
    }) + ":";

  const REQUIRED = Text({ tid: "REQUIRED", def: "Required" });
  const YES = Text({ tid: "YES", def: "Yes" });
  const NO = Text({ tid: "NO", def: "No" });
  const DESC = Text({ tid: "DESC", def: " " });
  const PREVIEW = Text({ tid: "PREVIEW", def: "Preview" });

  const SELECT_DATE = Text({
    tid: "SELECT_DATE",
    def: "MM-YYYY",
  });
  const SELECT_YEAR = Text({
    tid: "SELECT_YEAR",
    def: "Select Year",
  });
  const REMOVE = Text({ tid: "REMOVE", def: " " });
  const ADD = Text({ tid: "ADD", def: " " });

  const MULANT = Text({ tid: "MULANT", def: "MULANT" });
  const LEVEL_1 = Text({ tid: "LEVEL_1", def: "LEVEL_1" });
  const LEVEL_2 = Text({ tid: "LEVEL_2", def: "LEVEL_2" });
  const UCCHTAR = Text({ tid: "UCCHTAR", def: "UCCHTAR" });

  const STUDENT_PT2_Q3_A_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q3_A_PLACEHOLDER",
    def: "Ex. Priyavrat Sharma",
  });

  const STUDENT_PT2_Q3_C_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q3_C_PLACEHOLDER",
    def: "15",
  });

  const STUDENT_PT2_Q3_E_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT2_Q3_E_PLACEHOLDER",
    def: "Ex. Level-2",
  });

  const END_DATE_BEFORE_START_DATE = Text({
    tid: "END_DATE_BEFORE_START_DATE",
    def: "End date cannot be before start date",
  });

  const FIRST = Text({ tid: "FIRST", def: "First" });
  const SECOND = Text({ tid: "SECOND", def: "Second" });
  const THIRD = Text({ tid: "THIRD", def: "Third" });

  useEffect(() => {
    const fieldsToInitialize = [
      "STUDENT_2026_PT2_Q4",
      "STUDENT_2026_PT2_Q5",
      "STUDENT_2026_PT2_Q6",
      "STUDENT_2026_PT2_Q7",
      "STUDENT_2026_PT2_Q8",
    ];

    fieldsToInitialize.forEach((field) => {
      if (
        !form.getFieldValue(field) ||
        form.getFieldValue(field).length === 0
      ) {
        form.setFieldsValue({ [field]: [{}] });
      }
    });
  }, []);

  useEffect(() => {
    if (searchParams) {
      // Decrypt and set formId, userId, and formFor from URL search parameters
      const fId = EncryptUtils.decrypt(searchParams.get("id") || "");
      const uId = EncryptUtils.decrypt(searchParams.get("ui") || "");
      const fFor = EncryptUtils.decrypt(searchParams.get("ff") || "");
      setFormId(fId);
      setUserId(uId);
      setFormFor(fFor);
    }
    if (currentFormId) {
      setFormId(EncryptUtils.decrypt(currentFormId));
    }
    if (currentUserId) {
      setUserId(EncryptUtils.decrypt(currentUserId));
    }
    if (currentFormFor) {
      setFormFor(EncryptUtils.decrypt(currentFormFor));
    }
  }, [searchParams, currentFormId, currentUserId, currentFormFor]);

  // Helper function to properly serialize table data with file fields cleared
  /**
   * Builds a JSON-serialized array payload for handleFieldChange.
   *
   * @param currentData  - Current array from form.getFieldValue(parentKey)
   * @param fieldsToStrip - Native <input type="file"> field keys to clear (NOT _DOC url fields)
   * @param patch        - Optional: inject a new value at a specific row before serializing.
   *                       Use this to avoid the setFieldValue race condition in onUploadComplete.
   */
  const buildArrayPayload = (
    currentData: any[],
    fieldsToStrip: string[] = [],
    patch?: { rowIndex: number; fieldKey: string; value: any },
  ): string => {
    return JSON.stringify(
      (currentData || []).map((item: any, i: number) => {
        // Apply patch to the target row (avoids setFieldValue async race condition)
        const rawRow =
          patch && i === patch.rowIndex
            ? { ...item, [patch.fieldKey]: patch.value }
            : { ...item };

        const row = { ...rawRow };

        // Format Date fields (Dayjs -> String)
        // This mirrors SchoolPartTwo's serializeTableData formatting logic
        Object.keys(row).forEach((key) => {
          const val = row[key];
          if (dayjs.isDayjs(val)) {
            // Check for specific Month-Year fields in Q4, Q6, Q7, Q8
            if (
              [
                "STUDENT_2026_PT2_Q4_A",
                "STUDENT_2026_PT2_Q4_B",
                "STUDENT_2026_PT2_Q4_D",
                "STUDENT_2026_PT2_Q5_A",
                "STUDENT_2026_PT2_Q5_B",
                "STUDENT_2026_PT2_Q6_C",
                "STUDENT_2026_PT2_Q6_D",
                "STUDENT_2026_PT2_Q6_E",
                "STUDENT_2026_PT2_Q7_A",
                "STUDENT_2026_PT2_Q8_D",
              ].includes(key)
            ) {
              row[key] = val.format("MM/YYYY");
            } else {
              // Default fallback
              row[key] = val.format("YYYY-MM-DD");
            }
          }
        });

        // Strip native file input paths (browser fake paths, NOT stored doc URLs)
        fieldsToStrip.forEach((f) => {
          row[f] = "";
        });

        return row;
      }),
    );
  };

  // -----------------------------------------DOC-SUMMARY-TABLE-COLUMNS-----------------------------------------
  const TABLE_COLUMNS_STUDENT_DOC_SUMMARY: TableProps<any>["columns"] = [
    {
      title: Text({ tid: "SERIAL_NUMBER", def: "SERIAL_NUMBER" }),
      dataIndex: "serialNumber",
      key: "serialNumber",
      width: "100px",
      render: (_, record, index) => getNumberInLanguage(index + 1),
    },
    {
      title: Text({ tid: "DOCUMENT_DETAILS", def: "Document Details" }),
      dataIndex: "documentDetails",
      key: "documentDetails",
    },
    {
      title: Text({ tid: "PREVIEW", def: "Preview" }),
      dataIndex: "documentUrl",
      key: "documentUrl",
      render: (_, record: any) => {
        const documentUrl = record.documentUrl;
        if (!documentUrl)
          return <span style={{ color: "#ccc" }}>No document</span>;

        const fullUrl = `${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${documentUrl}`;
        const isPdf = documentUrl.toLowerCase().endsWith(".pdf");

        if (isPdf) {
          return (
            <a
              href={fullUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="primary-link"
            >
              <FilePdfOutlined style={{ fontSize: "24px", color: "#ff4d4f" }} />
            </a>
          );
        }

        return <Image width={50} src={fullUrl} alt="Preview" />;
      },
    },
  ];

  const handleFieldChange = async (
    field: string,
    value: any,
    answerType: number = eAnswerType.TEXT,
    bulkPayload?: any[],
    isSubmitted?: boolean,
  ) => {
    if (formId?.length) {
      try {
        setIsSubmitting(true);

        const answers: any[] = [];

        // Handle single field
        if (field.length > 0) {
          const trimmedValue = typeof value === "string" ? value.trim() : value;
          if (trimmedValue === null || trimmedValue === undefined) {
            form.setFieldValue(field, "");
            // Continue execution to save the empty string to backend
          }

          // Auto-detect answer type from JSON strings or Raw Arrays
          let detectedType = answerType;
          if (typeof trimmedValue === "string") {
            if (trimmedValue.startsWith("[")) {
              detectedType = eAnswerType.ARRAY;
            } else if (trimmedValue.startsWith("{")) {
              detectedType = eAnswerType.OBJECT;
            }
          } else if (Array.isArray(trimmedValue)) {
            detectedType = eAnswerType.ARRAY;
          }

          // Format answer based on type
          let formattedAnswer = trimmedValue;

          if (Array.isArray(trimmedValue)) {
            // Use buildArrayPayload to ensure Date formatting (MM/YYYY)
            formattedAnswer = buildArrayPayload(trimmedValue);
          } else if (
            detectedType === eAnswerType.ARRAY ||
            detectedType === eAnswerType.OBJECT
          ) {
            formattedAnswer =
              typeof trimmedValue === "string"
                ? trimmedValue
                : JSON.stringify(trimmedValue);
          } else if (
            detectedType === eAnswerType.DATE &&
            typeof trimmedValue === "object" &&
            trimmedValue?.format
          ) {
            formattedAnswer = trimmedValue.format("YYYY-MM-DD");
          }

          answers.push({
            questionKey: field,
            answerType: detectedType,
            answer: formattedAnswer,
            part: eSTAGE.STAGE2,
          });
        }

        // Handle bulk payload (multiple answers)
        if (bulkPayload && Array.isArray(bulkPayload)) {
          answers.push(...bulkPayload);
        }

        const payload: any = {
          data: {
            id: formId,
            answers: answers,
          },
        };

        if (isSubmitted) {
          payload.data.isSubmitted = true;
        }

        const response = await post(updateField, payload);
        const { dataResponse } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode == eResultCode.SUCCESS) {
          if (isSubmitted) {
            onShowToast({
              type: ToastType.success,
              title: <FaCheck />,
              position: ToastOpen.leftBottom,
              content: "Form Submitted Successfully!",
            });
            setTimeout(() => {
              navigate("/");
            }, 1000);
          }
        } else if (returnCode == eResultCode.INVALID_REQUEST) {
          onShowToast({
            type: ToastType.error,
            title: <ExclamationCircleOutlined />,
            position: ToastOpen.leftBottom,
            content: description,
          });
        }
      } catch (error) {
        console.error("Student Form 2 Error: ", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const getFormData = async () => {
    setIsLoading(true);
    try {
      const payload: any = {
        data: {
          id: formId,
          part: eSTAGE.STAGE2,
          isPtOne: false,
          year: CURRENT_YEAR,
          userFormType: eUSER_FORM_TYPE.STUDENT,
          userId: userId,
          formFor: formFor,
        },
      };

      const response = await post(GetFormData, payload);
      const { dataResponse, data } = response;
      const { returnCode, description } = dataResponse;
      if (returnCode == eResultCode.SUCCESS && Array.isArray(data)) {
        // Convert array of answers to form field values
        const formattedData: { [key: string]: any } = {};
        const docs: any[] = [];
        const DATE_FIELD_KEYS: string[] = [
          "STUDENT_2026_PT2_Q13", // Affidavit Date
        ];

        data.forEach((answer: any) => {
          const { questionKey, answerType, answer: answerValue } = answer;

          if (!questionKey) return;

          // Parse based on answerType
          switch (answerType) {
            case eAnswerType.ARRAY:
            case eAnswerType.OBJECT:
              try {
                formattedData[questionKey] = answerValue
                  ? JSON.parse(answerValue)
                  : answerType === eAnswerType.ARRAY
                    ? []
                    : {};
              } catch (error) {
                console.error(`Error parsing ${questionKey}:`, error);
                formattedData[questionKey] =
                  answerType === eAnswerType.ARRAY ? [] : {};
              }
              break;
            case eAnswerType.FILE:
              // File fields store document ID, don't set in form
              formattedData[questionKey] = answerValue || "";
              if (answerValue) {
                docs.push({
                  docPath: answerValue,
                  labelName: questionKey, // linking doc to question
                });
              }
              break;
            case eAnswerType.DATE:
              // Convert date string to dayjs object for DatePicker
              formattedData[questionKey] = Utils.parseToDayjs(answerValue);
              break;
            case eAnswerType.TEXT:
            default:
              formattedData[questionKey] = answerValue || "";

              // Force Date Conversion for known date fields if they come as TEXT
              if (DATE_FIELD_KEYS.includes(questionKey) && answerValue) {
                formattedData[questionKey] = Utils.parseToDayjs(answerValue);
              }
              break;
          }
        });

        // Convert year fields in table data to dayjs objects for DatePicker

        // Define which fields in which arrays need Date conversion (all are MM-YYYY in Student Part 2)
        const arrayDateFields: Record<string, string[]> = {
          STUDENT_2026_PT2_Q4: [
            "STUDENT_2026_PT2_Q4_A",
            "STUDENT_2026_PT2_Q4_B",
            "STUDENT_2026_PT2_Q4_D",
          ],
          STUDENT_2026_PT2_Q5: [
            "STUDENT_2026_PT2_Q5_A",
            "STUDENT_2026_PT2_Q5_B",
          ],
          STUDENT_2026_PT2_Q6: [
            "STUDENT_2026_PT2_Q6_C",
            "STUDENT_2026_PT2_Q6_D",
            "STUDENT_2026_PT2_Q6_E",
          ],
          STUDENT_2026_PT2_Q7: ["STUDENT_2026_PT2_Q7_A"],
          STUDENT_2026_PT2_Q8: ["STUDENT_2026_PT2_Q8_D"],
        };

        Object.keys(arrayDateFields).forEach((tableKey) => {
          if (Array.isArray(formattedData[tableKey])) {
            formattedData[tableKey] = formattedData[tableKey].map(
              (row: any) => {
                const newRow = { ...row };
                arrayDateFields[tableKey].forEach((dateKey) => {
                  const val = newRow[dateKey];
                  if (val) {
                    const resultDate = Utils.parseToDayjs(val);
                    newRow[dateKey] = resultDate;
                  }
                });
                return newRow;
              },
            );
          }
        });

        if (docs.length > 0) {
          setDocumentsData(docs);
        }

        if (Object.keys(formattedData).length > 0) {
          form.setFieldsValue(sanitizeFormData(formattedData));

          // Initialize Q3 Form.List if Q3_CONFIRMATION is YES but Q3 has no items yet
          const q3Confirmation = form.getFieldValue(
            "STUDENT_2026_PT2_Q3_CONFIRMATION",
          );
          const q3Value = form.getFieldValue("STUDENT_2026_PT2_Q3");
          if (
            (q3Confirmation === "YES" || q3Confirmation === eYES_OR_NO.YES) &&
            (!Array.isArray(q3Value) || q3Value.length === 0)
          ) {
            form.setFieldValue("STUDENT_2026_PT2_Q3", [{}]);
          }

          // Initialize Q7 Form.List if Q7_CONFIRMATION is YES but Q7 has no items yet
          const q7Confirmation = form.getFieldValue(
            "STUDENT_2026_PT2_Q7_CONFIRMATION",
          );
          const q7Value = form.getFieldValue("STUDENT_2026_PT2_Q7");
          if (
            (q7Confirmation === "YES" || q7Confirmation === eYES_OR_NO.YES) &&
            (!Array.isArray(q7Value) || q7Value.length === 0)
          ) {
            form.setFieldValue("STUDENT_2026_PT2_Q7", [{}]);
          }

          // Initialize Q8 Form.List if Q8_CONFIRMATION is YES but Q8 has no items yet
          const q8Confirmation = form.getFieldValue(
            "STUDENT_2026_PT2_Q8_CONFIRMATION",
          );
          const q8Value = form.getFieldValue("STUDENT_2026_PT2_Q8");
          if (
            (q8Confirmation === "YES" || q8Confirmation === eYES_OR_NO.YES) &&
            (!Array.isArray(q8Value) || q8Value.length === 0)
          ) {
            form.setFieldValue("STUDENT_2026_PT2_Q8", [{}]);
          }

          // Sync affidavitAccepted state with loaded form data
          if (
            formattedData.affidavitAccepted ||
            formattedData.affidavitAccepted === "1"
          ) {
            form.setFieldValue("affidavitAccepted", true);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // === GLOBAL DATE SANITIZER ===
  // Prevents date.isValid crashes by ensuring all DatePicker fields have valid dayjs or null
  const DATE_FIELD_SUFFIXES = new Set([
    "STUDENT_2026_PT2_Q4_A",
    "STUDENT_2026_PT2_Q4_B",
    "STUDENT_2026_PT2_Q4_D",
    "STUDENT_2026_PT2_Q5_A",
    "STUDENT_2026_PT2_Q5_B",
    "STUDENT_2026_PT2_Q6_C",
    "STUDENT_2026_PT2_Q6_D",
    "STUDENT_2026_PT2_Q6_E",
    "STUDENT_2026_PT2_Q7_A",
    "STUDENT_2026_PT2_Q8_D",
    "STUDENT_2026_PT2_Q13",
  ]);

  const sanitizeFormData = (data: Record<string, any>): Record<string, any> => {
    const sanitized: Record<string, any> = {};
    for (const [key, value] of Object.entries(data)) {
      if (DATE_FIELD_SUFFIXES.has(key)) {
        // Top-level date field: must be dayjs or null
        if (dayjs.isDayjs(value) && value.isValid()) {
          sanitized[key] = value;
        } else if (typeof value === "string" && value) {
          sanitized[key] = Utils.parseToDayjs(value);
        } else {
          sanitized[key] = null;
        }
      } else if (Array.isArray(value)) {
        // Array (Form.List): recursively sanitize each row
        sanitized[key] = value.map((row: any) => {
          if (!row || typeof row !== "object") return row;
          const sanitizedRow: any = {};
          for (const [rk, rv] of Object.entries(row)) {
            if (DATE_FIELD_SUFFIXES.has(rk)) {
              if (dayjs.isDayjs(rv) && (rv as any).isValid()) {
                sanitizedRow[rk] = rv;
              } else if (typeof rv === "string" && rv) {
                sanitizedRow[rk] = Utils.parseToDayjs(rv);
              } else {
                sanitizedRow[rk] = null;
              }
            } else {
              sanitizedRow[rk] = rv;
            }
          }
          return sanitizedRow;
        });
      } else {
        sanitized[key] = value;
      }
    }
    return sanitized;
  };

  /**
   * Helper function to safely parse and map form data from API response
   * Maps 2025 field names to 2026 field names
   */
  const getMappedData = (data: any) => {
    if (!data) return {};

    // Helper: map an array of objects with custom keys to 2026 prefixed keys
    const mapArrayWithCustomKeys = (
      sourceArr: any[],
      keyMap: Record<string, string>, // { "2026_suffix": "2025_json_key" }
      prefixTo: string,
      dateKeys: string[] = [],
    ): any[] => {
      if (!Array.isArray(sourceArr) || sourceArr.length === 0) {
        const emptyItem: any = {};
        Object.keys(keyMap).forEach((k) => {
          emptyItem[`${prefixTo}${k}`] = dateKeys.includes(k) ? null : "";
        });
        return [emptyItem];
      }
      return sourceArr.map((item) => {
        if (!item) return {};
        const newItem: any = {};
        Object.entries(keyMap).forEach(([toSuffix, fromKey]) => {
          const val =
            item[fromKey] !== undefined && item[fromKey] !== null
              ? item[fromKey]
              : "";
          if (dateKeys.includes(toSuffix)) {
            newItem[`${prefixTo}${toSuffix}`] =
              val && val !== "Invalid Date" ? Utils.parseToDayjs(val) : null;
          } else {
            newItem[`${prefixTo}${toSuffix}`] = val || "";
          }
        });
        return newItem;
      });
    };

    // --- Q4: VedPariksha details (2025 Q4 array -> 2026 Q4 array) ---
    // 2025: [{Q4_A: start_date, Q4_B: end_date, Q4_C: level, Q4_D: exam_date, Q4_E: result}]
    // 2026: Q4_A(DatePicker), Q4_B(DatePicker), Q4_C(level), Q4_D(DatePicker), Q4_E(result)
    const q4Mapped = mapArrayWithCustomKeys(
      data.STUDENT_PT2_Q4,
      {
        A: "STUDENT_PT2_Q4_A",
        B: "STUDENT_PT2_Q4_B",
        C: "STUDENT_PT2_Q4_C",
        D: "STUDENT_PT2_Q4_D",
        E: "STUDENT_PT2_Q4_E",
      },
      "STUDENT_2026_PT2_Q4_",
      ["A", "B", "D"],
    );

    // --- Q5: VedAdhyayan (2025 Q7 array -> 2026 Q5 array) ---
    // 2025: [{Q7_A: month, Q7_B: teacher_name, Q7_C: institution}]
    // 2026: Q5_A(DatePicker month), Q5_B(DatePicker month), Q5_C(teacher), Q5_D(institution)
    const q5Mapped = mapArrayWithCustomKeys(
      data.STUDENT_PT2_Q7,
      {
        A: "STUDENT_PT2_Q7_A",
        B: "STUDENT_PT2_Q7_B",
        C: "STUDENT_PT2_Q7_C",
      },
      "STUDENT_2026_PT2_Q5_",
      ["A"],
    );

    // --- Q6: Workshops/Camps (2025 Q8 array -> 2026 Q6 array) ---
    // 2025: [{Q8_A, Q8_B, Q8_C, Q8_D, Q8_DOC}]
    // 2026: Q6_A(name), Q6_B(organizer), Q6_C(DatePicker), Q6_D(DatePicker), Q6_E(venue), Q6_DOC
    const q6Mapped = mapArrayWithCustomKeys(
      data.STUDENT_PT2_Q8,
      {
        A: "STUDENT_PT2_Q8_A",
        B: "STUDENT_PT2_Q8_B",
        C: "STUDENT_PT2_Q8_C",
        D: "STUDENT_PT2_Q8_D",
        DOC: "STUDENT_PT2_Q8_DOC",
      },
      "STUDENT_2026_PT2_Q6_",
      ["C", "D"],
    );

    // --- Q7: Activities (2025 Q9 array -> 2026 Q7 array) ---
    // 2025: [{Q9_A, Q9_B, Q9_C, Q9_D, Q9_DOC}]
    // 2026: Q7_A(DatePicker month), Q7_B(name), Q7_C(organizer), Q7_DOC
    const q7Mapped = mapArrayWithCustomKeys(
      data.STUDENT_PT2_Q9,
      {
        A: "STUDENT_PT2_Q9_A",
        B: "STUDENT_PT2_Q9_B",
        C: "STUDENT_PT2_Q9_C",
        DOC: "STUDENT_PT2_Q9_DOC",
      },
      "STUDENT_2026_PT2_Q7_",
      ["A"],
    );

    // --- Q8: Cultural activities (2025 Q10 array -> 2026 Q8 array) ---
    // 2025: [{Q10_A, Q10_B, Q10_C, Q10_D}]
    // 2026: Q8_A(name), Q8_B(organizer), Q8_C(venue), Q8_D(DatePicker month)
    const q8Mapped = mapArrayWithCustomKeys(
      data.STUDENT_PT2_Q10,
      {
        A: "STUDENT_PT2_Q10_A",
        B: "STUDENT_PT2_Q10_B",
        C: "STUDENT_PT2_Q10_C",
        D: "STUDENT_PT2_Q10_D",
      },
      "STUDENT_2026_PT2_Q8_",
      ["D"],
    );

    const mappedData: { [key: string]: any } = {
      STUDENT_2026_PT2_Q1: data.STUDENT_PT2_Q1 || "",
      STUDENT_2026_PT2_Q2: data.STUDENT_PT2_Q2 || "",
      STUDENT_2026_PT2_Q4: q4Mapped,
      // Q3 (address) mapped from Q3 directly
      STUDENT_2026_PT2_Q5: q5Mapped,
      STUDENT_2026_PT2_Q6: q6Mapped,
      STUDENT_2026_PT2_Q7: q7Mapped,
      STUDENT_2026_PT2_Q8: q8Mapped,
      // Affidavit fields
      STUDENT_2026_PT2_Q10: data.STUDENT_PT2_Q11 || "",
      STUDENT_2026_PT2_Q11: data.STUDENT_PT2_Q12 || "",
      STUDENT_2026_PT2_Q12: data.STUDENT_PT2_Q13 || "",
      STUDENT_2026_PT2_Q13: data.STUDENT_PT2_Q14
        ? Utils.parseToDayjs(data.STUDENT_PT2_Q14)
        : null,
    };

    // Filter out null/undefined values to avoid overwriting existing data
    return Object.fromEntries(
      Object.entries(mappedData).filter(
        ([_, value]) => value !== null && value !== undefined && value !== "",
      ),
    );
  };

  const getPreviousFormData = async () => {
    setIsLoading(true);
    try {
      const payload: any = {
        data: {
          part: eSTAGE.STAGE2,
          year: CURRENT_YEAR - 1,
          userFormType: eUSER_FORM_TYPE.STUDENT,
          userId: userId,
          formFor: formFor,
        },
      };

      const response = await post(GetFormData, payload);
      const { dataResponse, data } = response;
      const { returnCode } = dataResponse;

      if (returnCode == eResultCode.SUCCESS) {
        const formData = Object.values(data?.studentPt2Forms || {}).every(
          (value) => value === null,
        )
          ? {}
          : data?.studentPt2Forms || {};

        // List of fields that are JSON strings and need parsing
        const jsonStringFields = [
          "STUDENT_PT2_Q4",
          "STUDENT_PT2_Q6",
          "STUDENT_PT2_Q7",
          "STUDENT_PT2_Q8",
          "STUDENT_PT2_Q9",
          "STUDENT_PT2_Q10",
          "STUDENT_PT2_Q19",
        ];

        const fileFields = [
          "STUDENT_PT2_Q5",
          "STUDENT_PT2_Q17",
          "STUDENT_PT2_Q22",
          "STUDENT_PT2_Q26",
        ];

        const formattedData = Object.keys(formData).reduce(
          (acc: { [key: string]: any }, key) => {
            if (jsonStringFields.includes(key)) {
              try {
                const parsedArr = formData[key]
                  ? JSON.parse(formData[key])
                  : [{}];
                acc[key] = parsedArr;
              } catch (error) {
                console.error(error);
                acc[key] = [{}];
              }
            } else if (fileFields.includes(key)) {
              acc[key] = "";
            } else {
              acc[key] = formData[key];
            }
            return acc;
          },
          {},
        );

        // All date conversion is now safely handled by getMappedData + sanitizeFormData
        const mappedData = getMappedData(formattedData);

        // Remove dropdown values ONLY from previous year (2025) data
        // so the user must select them manually in the 2026 form.
        if (Array.isArray(mappedData.STUDENT_2026_PT2_Q4)) {
          mappedData.STUDENT_2026_PT2_Q4 = mappedData.STUDENT_2026_PT2_Q4.map(
            (row: any) => ({
              ...row,
              STUDENT_2026_PT2_Q4_E: undefined, // Examination Institute dropdown
              STUDENT_2026_PT2_Q4_F: undefined, // Result Category dropdown
              STUDENT_2026_PT2_Q4_E_OTHER: undefined, // Other Institute field
            }),
          );
        }

        // Set remaining values from previous year
        if (mappedData && Object.keys(mappedData).length > 0) {
          form.setFieldsValue(sanitizeFormData(mappedData));
          setTimeout(() => {
            const uploadedDocuments = getUploadedDocuments();
            form.setFieldsValue({
              STUDENT_ATTACHED_DOCS_SUMMARY: uploadedDocuments,
            });
          }, 100);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const autoFillPartOneData = async () => {
    setIsLoading(true);
    try {
      const payload: any = {
        data: {
          id: formId,
          part: eSTAGE.STAGE1,
          isPtOne: true,
          year: CURRENT_YEAR,
          userFormType: eUSER_FORM_TYPE.STUDENT,
          userId: userId,
          formFor: formFor,
        },
      };
      const response = await post(GetFormData, payload);
      const { dataResponse, data } = response;
      const { returnCode } = dataResponse;
      if (returnCode == eResultCode.SUCCESS) {
        if (data && Object.keys(data).length > 0) {
          const name = data.find(
            (item: any) => item.questionKey === "STUDENT_2026_PT1_Q1",
          )?.answer;
          const aadhaar = data.find(
            (item: any) => item.questionKey === "STUDENT_2026_PT1_Q7",
          )?.answer;
          form.setFieldsValue({
            STUDENT_2026_PT2_Q1: name,
            STUDENT_2026_PT2_Q2: aadhaar,
            STUDENT_2026_PT2_Q10: name,
            STUDENT_2026_PT2_Q11: name,
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (formId && formFor && user) {
      const fetchData = async () => {
        // await getPreviousFormData();
        await getFormData();
        await autoFillPartOneData();
      };
      fetchData();
    }
  }, [formId, formFor, userId, user]);

  // Function to collect all uploaded document titles from array fields
  const getUploadedDocuments = () => {
    const documents: { documentDetails: string; documentUrl?: string }[] = [];

    // Collect from Q4 (Traditional Exam Certificates)
    const q4Data = form.getFieldValue("STUDENT_2026_PT2_Q4") || [];
    q4Data.forEach((item: any) => {
      if (item?.STUDENT_2026_PT2_Q4_DOC) {
        const examName = item?.STUDENT_2026_PT2_Q4_C
          ? dictionary?.[item.STUDENT_2026_PT2_Q4_C] ||
            item.STUDENT_2026_PT2_Q4_C
          : "Traditional Exam";
        documents.push({
          documentDetails: `${examName} ${certificateLabel}`,
          documentUrl: item.STUDENT_2026_PT2_Q4_DOC,
        });
      }
    });

    // Collect from Q6 (Basic Education)
    const q6Data = form.getFieldValue("STUDENT_2026_PT2_Q6") || [];
    q6Data.forEach((item: any) => {
      if (item?.STUDENT_2026_PT2_Q6_DOC) {
        const examName = item?.STUDENT_2026_PT2_Q6_A
          ? dictionary?.[item.STUDENT_2026_PT2_Q6_A] ||
            item.STUDENT_2026_PT2_Q6_A
          : "Basic Form";
        documents.push({
          documentDetails: `${examName} ${certificateLabel}`,
          documentUrl: item.STUDENT_2026_PT2_Q6_DOC,
        });
      }
    });

    // Collect from Q7 (Other Education)
    const q7Data = form.getFieldValue("STUDENT_2026_PT2_Q7") || [];
    q7Data.forEach((item: any) => {
      if (item?.STUDENT_2026_PT2_Q7_DOC) {
        let certName = "Education Certificate";
        if (item?.STUDENT_2026_PT2_Q7_A === "11") {
          certName = dictionary?.["HSC"] || "HSC Certificate";
        } else if (item?.STUDENT_2026_PT2_Q7_A === "12") {
          certName =
            dictionary?.["BOARD_OF_UNIVERSITY"] ||
            "Board/University Certificate";
        }
        documents.push({
          documentDetails: certName,
          documentUrl: item.STUDENT_2026_PT2_Q7_DOC,
        });
      }
    });

    return documents;
  };

  // Auto-update Document Summary list whenever documents are uploaded in the respective sections
  const q4WatchData = Form.useWatch("STUDENT_2026_PT2_Q4", form);
  const q6WatchData = Form.useWatch("STUDENT_2026_PT2_Q6", form);
  const q7WatchData = Form.useWatch("STUDENT_2026_PT2_Q7", form);
  const q4Watchdata = Form.useWatch("STUDENT_2026_PT2_Q4", form);

  const isOtherInstitute = (index: number) => {
    const selectedInstituteOther = q4Watchdata?.[index]?.STUDENT_2026_PT2_Q4_E;
    return selectedInstituteOther === "INSTITUTE_OTHER";
  };

  const { handleFormSubmit, onFormValuesChange, debouncedSave } =
    useFormAutoSave({
      formId: formId || "",
      form,
      stage: eSTAGE.STAGE2,
      handleFieldChange,
      excludeFields: [
        "STUDENT_2026_PT2_Q9",
        "STUDENT_2026_PT2_Q14",
        "STUDENT_2026_PT2_Q15",
        "STUDENT_2026_PT2_Q16",
      ],
    });

  useEffect(() => {
    const uploadedDocuments = getUploadedDocuments();
    form.setFieldsValue({
      STUDENT_ATTACHED_DOCS_SUMMARY: uploadedDocuments,
    });
    debouncedSave(
      "STUDENT_ATTACHED_DOCS_SUMMARY",
      JSON.stringify(uploadedDocuments),
    );
  }, [q4WatchData, q6WatchData, q7WatchData]);

  // Centralized handler for local side-effects + auto-save
  const handleLocalFormChange = (changedValues: any, allValues: any) => {
    onFormValuesChange(changedValues, allValues);

    // Q1 Side Effect: Copy Name to Q27, Q28
    if ("STUDENT_2026_PT2_Q1" in changedValues) {
      const value = changedValues.STUDENT_2026_PT2_Q1;
      if (value) {
        form.setFieldValue("STUDENT_2026_PT2_Q10", value);
        debouncedSave("STUDENT_2026_PT2_Q10", value);
        form.setFieldValue("STUDENT_2026_PT2_Q11", value);
        debouncedSave("STUDENT_2026_PT2_Q11", value);
      }
    }
  };

  // const scrollToField = (fieldName: any) => {
  //   console.log("scrollToField", fieldName);
  //   setTimeout(() => {
  //     form.scrollToField(fieldName, {
  //       behavior: "smooth",
  //       block: "center",
  //     });

  //     let selector = "";

  //     if (Array.isArray(fieldName)) {
  //       selector = `[id="${fieldName.join("_")}"]`;
  //     } else {
  //       selector = `[id="${fieldName}"]`;
  //     }

  //     const inputElement =
  //       document.querySelector(selector) ||
  //       document.querySelector(`${selector} input`) ||
  //       document.querySelector(`${selector} .ant-picker-input input`) ||
  //       document.querySelector(".ant-form-item-has-error");

  //     if (inputElement) {
  //       inputElement.scrollIntoView({
  //         behavior: "smooth",
  //         block: "center",
  //       });

  //       (inputElement as HTMLElement).focus?.();
  //     }
  //   }, 300);
  // };

  const scrollToField = (fieldName: string) => {
    console.log("fieldName", fieldName);
    setTimeout(() => {
      form.scrollToField(fieldName, {
        behavior: "smooth",
        block: "center",
      });

      const element = document.getElementById(fieldName);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 200);
  };

  // Handle "Next" button click - validates form and enters review mode
  const handleNextClick = async () => {
    try {
      await form.validateFields();

      const values = form.getFieldsValue(true);

      // Check Q4 docs
      const q4Missing = (values.STUDENT_2026_PT2_Q4 || []).findIndex(
        (item: any) => !item?.STUDENT_2026_PT2_Q4_DOC,
      );

      if (q4Missing !== -1) {
        scrollToField(`STUDENT_2026_PT2_Q4_${q4Missing}_DOC`);
        return;
      }

      // Check Q6 docs
      const q6Missing = (values.STUDENT_2026_PT2_Q6 || []).findIndex(
        (item: any) => !item?.STUDENT_2026_PT2_Q6_DOC,
      );

      if (q6Missing !== -1) {
        scrollToField(`STUDENT_2026_PT2_Q6_${q6Missing}_DOC`);
        return;
      }

      setIsReviewMode(true);

      document.getElementById("studentFormPart2")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } catch (errorInfo: any) {
      if (errorInfo?.errorFields?.length > 0) {
        scrollToField(errorInfo.errorFields[0].name);
      }
    }
  };

  // Handle "Back" button click - exits review mode to allow editing
  const handleBackClick = () => setIsReviewMode(false);

  const LengthCounter: React.FC<{
    form: any;
    fieldName: string | string[];
  }> = ({ form, fieldName }) => {
    // Use useWatch to get real-time updates for the field value
    const fieldValue = Form.useWatch(fieldName, form);

    return (
      <div className="length_counter">
        {(fieldValue || "").length}/{INPUT_LENGTH.TEXTAREA_LENGTH}
      </div>
    );
  };

  const inputRequiredBasicRule: Rule[] = [
    {
      required: true,
      message: Text({ tid: "REQUIRED", def: "Required" }),
    },
  ];

  const otherInstitute = Text({
    tid: "OTHER_INSTITUTE",
    def: "Institute Name",
  });

  const OTHER_INSTITUTE_PLACEHOLDER = Text({
    tid: "STUDENT_2026_PT1_Q20_D_OTHER_PLACEHOLDER",
    def: "Ex. Sanatan Vaidik Shikshan Sansthan",
  });

  const handleDateChange = (
    form: any,
    fieldName: string,
    index: number,
    dateString: string,
    handleFieldChange: (field: string, value: any) => void,
  ) => {
    // Wait for next tick to ensure Ant Design has updated the form state
    setTimeout(() => {
      const currentData = form.getFieldValue(fieldName) || [];
      handleFieldChange(fieldName, buildArrayPayload(currentData));
    }, 0);
  };

  const handleGeneratePDF = (id: string, fileName: string) => {
    setApplyPdfStyles(true);
    setTimeout(() => {
      Utils.generatePDF(id, fileName);
      setApplyPdfStyles(false);
    }, 0);
  };

  return (
    <div
      id="studentFormPart2"
      className={`${styles.formWrapper} studentPartTwo studentTeacherSchoolFormWrapper`}
    >
      <Form
        {...formItemLayout}
        form={form}
        name="register"
        onFinish={handleFormSubmit}
        onValuesChange={handleLocalFormChange}
        initialValues={{}}
        scrollToFirstError
        layout="vertical"
      >
        <Row>
          <Flex
            gap="middle"
            align="start"
            justify="space-between"
            style={{ width: "100%" }}
          >
            <Col>
              <Typography.Title level={3}>
                {Text({
                  tid: "STUDENT_2026_PART_2_FORM_HEADING",
                  def: "STUDENT_PART_2_FORM_HEADING",
                })}
              </Typography.Title>
              {!disabled && (
                <Typography.Text type="danger">
                  {Text({
                    tid: "all_fields_are_mandatory",
                    def: "All fields are mandatory!",
                  })}
                </Typography.Text>
              )}
            </Col>
          </Flex>
        </Row>
        {isReviewMode && (
          <Row style={{ marginBottom: 10 }}>
            <Typography.Text type="warning">
              <CheckCircleOutlined style={{ marginRight: 6 }} />
              {Text({
                tid: "REVIEW_MODE_INSTRUCTION",
                def: "You are in review mode. You can only view the submitted data. To make changes, please switch to edit mode.",
              })}
            </Typography.Text>
          </Row>
        )}
        <Row>
          {/* 1. Name */}
          <Col xs={24} lg={12} xl={8}>
            <Form.Item
              name="STUDENT_2026_PT2_Q1"
              label={Text({
                tid: "STUDENT_2026_PT2_Q1",
                def: "Name",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={true}
                placeholder={Text({
                  tid: "STUDENT_2026_PT2_Q1_PLACEHOLDER",
                  def: "Naresh Kumar",
                })}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 2. Aadhaar Card No. */}
        <Row>
          <Col xs={24} lg={12} xl={8}>
            <Form.Item
              name="STUDENT_2026_PT2_Q2"
              label={Text({
                tid: "STUDENT_2026_PT2_Q2",
                def: "Aadhaar Card",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: /^[2-9]{1}[0-9]{11}$/, // Aadhaar must be 12 digits and should not start with 0 or 1
                  message: Text({
                    tid: "aadhaar_card_validation",
                    def: "Aadhaar must be 12 digits and should not start with 0 or 1",
                  }),
                },
              ]}
            >
              <Input
                disabled={true}
                maxLength={12}
                onKeyDown={allowOnlyNumericInput_onKeyDown}
                placeholder={Text({
                  tid: "STUDENT_2026_PT2_Q2_PLACEHOLDER",
                  def: "Naresh Kumar",
                })}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* 3. Brother Sister Details*/}
        <Row>
          <Col xs={24} className="onClickRenderFields">
            <Form.Item
              name="STUDENT_2026_PT2_Q3_CONFIRMATION"
              label={STUDENT_PT2_Q3_CONFIRMATION}
              rules={[{ required: true, message: REQUIRED }]}
            >
              <Radio.Group
                disabled={disabled || isReviewMode}
                onChange={(e) => {
                  handleFieldChange(
                    "STUDENT_2026_PT2_Q3_CONFIRMATION",
                    e.target.value,
                  );
                  if (e.target.value === eYES_OR_NO.YES) {
                    const q3Value = form.getFieldValue("STUDENT_2026_PT2_Q3");
                    if (!Array.isArray(q3Value) || q3Value.length === 0) {
                      form.setFieldValue("STUDENT_2026_PT2_Q3", [{}]);
                    }
                  }
                }}
              >
                <Radio value="YES">{YES}</Radio>
                <Radio value="NO">{NO}</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={(prev, current) =>
                prev.STUDENT_2026_PT2_Q3_CONFIRMATION !==
                  current.STUDENT_2026_PT2_Q3_CONFIRMATION ||
                prev.STUDENT_2026_PT2_Q3 !== current.STUDENT_2026_PT2_Q3
              }
            >
              {({ getFieldValue }) =>
                getFieldValue("STUDENT_2026_PT2_Q3_CONFIRMATION") ===
                eYES_OR_NO.YES ? (
                  <>
                    <Typography.Text>{STUDENT_PT2_Q3}</Typography.Text>
                    <Form.List name="STUDENT_2026_PT2_Q3" initialValue={[{}]}>
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }, index) => (
                            <Space key={key} align="baseline">
                              <Row className="QuestionsSubSection">
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q3_A"]}
                                    label={STUDENT_PT2_Q3_A}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <Input
                                      disabled={disabled || isReviewMode}
                                      placeholder={STUDENT_PT2_Q3_A_PLACEHOLDER}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row className="QuestionsSubSection">
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q3_B"]}
                                    label={STUDENT_PT2_Q3_B}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <Select
                                      disabled={disabled || isReviewMode}
                                      placeholder={DROPDOWN_PLACEHOLDER}
                                    >
                                      <Select.Option value={BROTHER}>
                                        {BROTHER}
                                      </Select.Option>
                                      <Select.Option value={SISTER}>
                                        {SISTER}
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row className="QuestionsSubSection">
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q3_C"]}
                                    dependencies={[
                                      [
                                        "STUDENT_2026_PT2_Q3",
                                        name,
                                        "STUDENT_2026_PT2_Q3_B",
                                      ],
                                    ]}
                                    label={STUDENT_PT2_Q3_C}
                                  >
                                    <Input
                                      disabled={disabled || isReviewMode}
                                      onKeyDown={
                                        allowOnlyNumericInput_onKeyDown
                                      }
                                      placeholder={STUDENT_PT2_Q3_C_PLACEHOLDER}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row className="QuestionsSubSection">
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q3_D"]}
                                    label={STUDENT_PT2_Q3_D}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <Select
                                      disabled={disabled || isReviewMode}
                                      placeholder={DROPDOWN_PLACEHOLDER}
                                      onChange={(value) => {
                                        if (value === eYES_OR_NO.NO) {
                                          form.setFieldValue(
                                            [
                                              "STUDENT_2026_PT2_Q3",
                                              name,
                                              "STUDENT_2026_PT2_Q3_E",
                                            ],
                                            "",
                                          );
                                        }
                                      }}
                                    >
                                      <Select.Option value={eYES_OR_NO.YES}>
                                        {YES}
                                      </Select.Option>
                                      <Select.Option value={eYES_OR_NO.NO}>
                                        {NO}
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row className="QuestionsSubSection">
                                <Form.Item
                                  noStyle
                                  shouldUpdate={(prevValues, currentValues) => {
                                    const prevVal =
                                      prevValues.STUDENT_2026_PT2_Q3?.[name]
                                        ?.STUDENT_2026_PT2_Q3_D;
                                    const currVal =
                                      currentValues.STUDENT_2026_PT2_Q3?.[name]
                                        ?.STUDENT_2026_PT2_Q3_D;
                                    return prevVal !== currVal;
                                  }}
                                >
                                  {({ getFieldValue }) =>
                                    getFieldValue([
                                      "STUDENT_2026_PT2_Q3",
                                      name,
                                      "STUDENT_2026_PT2_Q3_D",
                                    ]) === eYES_OR_NO.YES ? (
                                      <Col xs={24} lg={12} xl={8}>
                                        <Form.Item
                                          {...restField}
                                          name={[name, "STUDENT_2026_PT2_Q3_E"]}
                                          label={STUDENT_PT2_Q3_E}
                                          rules={[
                                            {
                                              required: true,
                                              message: REQUIRED,
                                            },
                                          ]}
                                        >
                                          <Select
                                            disabled={disabled || isReviewMode}
                                            placeholder={DROPDOWN_PLACEHOLDER}
                                          >
                                            <Select.Option value={MULANT}>
                                              {MULANT}
                                            </Select.Option>
                                            <Select.Option value={LEVEL_1}>
                                              {LEVEL_1}
                                            </Select.Option>
                                            <Select.Option value={LEVEL_2}>
                                              {LEVEL_2}
                                            </Select.Option>
                                            <Select.Option value={UCCHTAR}>
                                              {UCCHTAR}
                                            </Select.Option>
                                          </Select>
                                        </Form.Item>
                                      </Col>
                                    ) : null
                                  }
                                </Form.Item>
                              </Row>
                              <Row>
                                <Col xs={24}>
                                  <Flex gap={30}>
                                    {form.getFieldValue("STUDENT_2026_PT2_Q3")
                                      .length > 1 && (
                                      <Form.Item>
                                        <Button
                                          disabled={disabled || isReviewMode}
                                          variant="filled"
                                          className="actionButton"
                                          onClick={() => {
                                            if (
                                              form.getFieldValue(
                                                "STUDENT_2026_PT2_Q3",
                                              ).length > 1
                                            ) {
                                              remove(name);
                                              handleFieldChange(
                                                "STUDENT_2026_PT2_Q3",
                                                JSON.stringify(
                                                  form.getFieldValue(
                                                    "STUDENT_2026_PT2_Q3",
                                                  ),
                                                ),
                                              );
                                            }
                                          }}
                                        >
                                          {REMOVE}
                                        </Button>
                                      </Form.Item>
                                    )}
                                    {form.getFieldValue("STUDENT_2026_PT2_Q3")
                                      .length -
                                      1 ===
                                      index && (
                                      <Form.Item>
                                        <Button
                                          disabled={disabled || isReviewMode}
                                          variant="filled"
                                          className="actionButton"
                                          onClick={() => {
                                            add();
                                            handleFieldChange(
                                              "STUDENT_2026_PT2_Q3",
                                              JSON.stringify(
                                                form.getFieldValue(
                                                  "STUDENT_2026_PT2_Q3",
                                                ),
                                              ),
                                            );
                                          }}
                                          block
                                        >
                                          {ADD}
                                        </Button>
                                      </Form.Item>
                                    )}
                                  </Flex>
                                </Col>
                              </Row>
                              {form.getFieldValue("STUDENT_2026_PT2_Q3")
                                .length -
                                1 >
                                index && <div className="divider"></div>}
                            </Space>
                          ))}
                        </>
                      )}
                    </Form.List>
                  </>
                ) : null
              }
            </Form.Item>
          </Col>
        </Row>

        {/* 4. वेदाध्ययन का क्रम व उत्तीर्ण परिक्षाएं: */}
        <Row>
          <Col xs={24} className="onClickRenderFields">
            <Typography.Text>
              {Text({
                tid: "STUDENT_2026_PT2_Q4",
                def: "वेदाध्ययन का क्रम व उत्तीर्ण परिक्षाएं:",
              })}
            </Typography.Text>
            <Typography.Text type="secondary">
              {Text({
                tid: "STUDENT_2026_PT2_Q4_HEADING",
                def: "यदि किसी एक स्तर पर एक से अधिक बार, अलग-अलग संस्थाओं में परीक्षा दी है, तो काल क्रम में सभी परीक्षाओं का विवरण दीजिये। यदि एक से अधिक वेद/शाखा का अध्ययन किया है, तो स्ववेदशाखा अध्ययन का विवरण देने के बाद अन्य अध्ययन का विवरण दीजिये।)",
              })}
            </Typography.Text>
            <Form.List name="STUDENT_2026_PT2_Q4">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => {
                    return (
                      <Space
                        key={key}
                        align="baseline"
                        className="QuestionsSubSection"
                      >
                        <Row>
                          <Col xs={24} lg={12} xl={8}>
                            <Form.Item
                              className="w-full"
                              {...restField}
                              name={[name, "STUDENT_2026_PT2_Q4_A"]}
                              label={STUDENT_2026_PT2_Q4_A}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <DatePicker
                                disabled={disabled || isReviewMode}
                                picker="month"
                                format="MM-YYYY"
                                disabledDate={(current) =>
                                  current && current > dayjs().endOf("month")
                                }
                                placeholder={SELECT_DATE}
                                style={{ width: "100%" }}
                                onChange={(date, dateString) =>
                                  handleDateChange(
                                    form,
                                    "STUDENT_2026_PT2_Q4",
                                    index,
                                    Array.isArray(dateString)
                                      ? dateString[0]
                                      : dateString,
                                    handleFieldChange,
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={24} lg={12} xl={8}>
                            <Form.Item
                              className="w-full"
                              {...restField}
                              name={[name, "STUDENT_2026_PT2_Q4_B"]}
                              dependencies={[
                                [
                                  "STUDENT_2026_PT2_Q4",
                                  name,
                                  "STUDENT_2026_PT2_Q4_A",
                                ],
                              ]}
                              label={STUDENT_2026_PT2_Q4_B}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const startDate = getFieldValue([
                                      "STUDENT_2026_PT2_Q4",
                                      name,
                                      "STUDENT_2026_PT2_Q4_A",
                                    ]);
                                    if (
                                      !value ||
                                      !startDate ||
                                      value.isAfter(startDate) ||
                                      value.isSame(startDate, "month")
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      END_DATE_BEFORE_START_DATE,
                                    );
                                  },
                                }),
                              ]}
                            >
                              <DatePicker
                                disabled={disabled || isReviewMode}
                                picker="month"
                                format="MM-YYYY"
                                disabledDate={(current) =>
                                  current && current > dayjs().endOf("month")
                                }
                                placeholder={SELECT_DATE}
                                style={{ width: "100%" }}
                                onChange={(date, dateString) =>
                                  handleDateChange(
                                    form,
                                    "STUDENT_2026_PT2_Q4",
                                    index,
                                    Array.isArray(dateString)
                                      ? dateString[0]
                                      : dateString,
                                    handleFieldChange,
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={24} lg={12} xl={8}>
                            <Form.Item
                              className="w-full"
                              {...restField}
                              name={[name, "STUDENT_2026_PT2_Q4_C"]}
                              label={STUDENT_2026_PT2_Q4_C}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled || isReviewMode}
                                placeholder={STUDENT_2026_PT2_Q4_C_PLACEHOLDER}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={24} lg={12} xl={8}>
                            <Form.Item
                              className="w-full"
                              {...restField}
                              name={[name, "STUDENT_2026_PT2_Q4_D"]}
                              label={STUDENT_2026_PT2_Q4_D}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <DatePicker
                                placeholder={SELECT_YEAR}
                                disabled={disabled || isReviewMode}
                                disabledDate={(current) =>
                                  current &&
                                  current.year() > new Date().getFullYear()
                                }
                                picker="month"
                                format="MM-YYYY"
                                onKeyDown={(e) => e.preventDefault()}
                                onChange={(date, dateString) =>
                                  handleDateChange(
                                    form,
                                    "STUDENT_2026_PT2_Q4",
                                    index,
                                    Array.isArray(dateString)
                                      ? dateString[0]
                                      : dateString,
                                    handleFieldChange,
                                  )
                                }
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={24} lg={12} xl={8}>
                            <Form.Item
                              className="w-full"
                              {...restField}
                              name={[name, "STUDENT_2026_PT2_Q4_E"]}
                              label={STUDENT_2026_PT2_Q4_E}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Select
                                disabled={disabled || isReviewMode}
                                placeholder={DROPDOWN_PLACEHOLDER}
                              >
                                {EXAM_INSTITUTE_LIST.map((item) => (
                                  <Select.Option
                                    key={item.value}
                                    value={item.value}
                                  >
                                    {dictionary?.[item.value] || item.label}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                        {isOtherInstitute(index) && (
                          <Row>
                            <Col xs={24} lg={12} xl={8}>
                              <Form.Item
                                name="STUDENT_2026_PT2_Q4_E_OTHER"
                                label={otherInstitute}
                                rules={inputRequiredBasicRule}
                              >
                                <Input
                                  disabled={disabled || isReviewMode}
                                  placeholder={OTHER_INSTITUTE_PLACEHOLDER}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col sm={24} lg={12} xl={8}>
                            <Form.Item
                              name={[name, "STUDENT_2026_PT2_Q4_F"]}
                              label={STUDENT_2026_PT2_Q4_F}
                              rules={inputRequiredBasicRule}
                            >
                              <Select
                                disabled={disabled || isReviewMode}
                                placeholder={DROPDOWN_PLACEHOLDER}
                              >
                                <Select.Option value="FIRST">
                                  {FIRST}
                                </Select.Option>
                                <Select.Option value="SECOND">
                                  {SECOND}
                                </Select.Option>
                                <Select.Option value="THIRD">
                                  {THIRD}
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={24} lg={12} xl={8}>
                            {(() => {
                              const docUrl = form.getFieldValue([
                                "STUDENT_2026_PT2_Q4",
                                name,
                                "STUDENT_2026_PT2_Q4_DOC",
                              ]);
                              const currentFieldName = `STUDENT_2026_PT2_Q4_${index}_DOC`;
                              return (
                                <div
                                  style={{ paddingLeft: "25px" }}
                                  id={currentFieldName}
                                >
                                  <DocumentUploadField
                                    formId={formId || ""}
                                    labelStyle={{ paddingLeft: "0px" }}
                                    userId={
                                      currentUserId
                                        ? currentUserId.toString()
                                        : ""
                                    }
                                    label={STUDENT_2026_PT2_Q4_G}
                                    fieldName={currentFieldName}
                                    existingDocuments={
                                      docUrl
                                        ? [
                                            {
                                              labelName: currentFieldName,
                                              docPath: docUrl,
                                            },
                                          ]
                                        : []
                                    }
                                    disabled={disabled || isReviewMode}
                                    onUploadComplete={(docUrl) => {
                                      // Set form value for UI display only
                                      form.setFieldValue(
                                        [
                                          "STUDENT_2026_PT2_Q4",
                                          name,
                                          "STUDENT_2026_PT2_Q4_DOC",
                                        ],
                                        docUrl,
                                      );
                                      // Use patch to inject docUrl directly — avoids setFieldValue race condition
                                      handleFieldChange(
                                        "STUDENT_2026_PT2_Q4",
                                        buildArrayPayload(
                                          form.getFieldValue(
                                            "STUDENT_2026_PT2_Q4",
                                          ),
                                          [],
                                          {
                                            rowIndex: name,
                                            fieldKey: "STUDENT_2026_PT2_Q4_DOC",
                                            value: docUrl,
                                          },
                                        ),
                                      );
                                    }}
                                  />
                                </div>
                              );
                            })()}
                          </Col>
                        </Row>
                        <Row style={{ marginTop: "25px" }}>
                          {/* Add Remove Button */}
                          <Col xs={24}>
                            <Flex gap={30}>
                              {form.getFieldValue("STUDENT_2026_PT2_Q4")
                                .length > 1 && (
                                <Form.Item>
                                  <Button
                                    disabled={disabled || isReviewMode}
                                    variant="filled"
                                    className="actionButton"
                                    onClick={() => {
                                      if (
                                        form.getFieldValue(
                                          "STUDENT_2026_PT2_Q4",
                                        ).length > 1
                                      ) {
                                        remove(name);
                                        // setTimeout(0) lets Ant Design flush the removal before we read form state
                                        setTimeout(() => {
                                          handleFieldChange(
                                            "STUDENT_2026_PT2_Q4",
                                            buildArrayPayload(
                                              form.getFieldValue(
                                                "STUDENT_2026_PT2_Q4",
                                              ),
                                            ),
                                          );
                                        }, 0);
                                      }
                                    }}
                                  >
                                    {REMOVE}
                                  </Button>
                                </Form.Item>
                              )}
                              {form.getFieldValue("STUDENT_2026_PT2_Q4")
                                .length -
                                1 ===
                                index && (
                                <Form.Item>
                                  <Button
                                    disabled={disabled || isReviewMode}
                                    variant="filled"
                                    className="actionButton"
                                    onClick={() => {
                                      add();
                                      handleFieldChange(
                                        "STUDENT_2026_PT2_Q4",
                                        buildArrayPayload(
                                          form.getFieldValue(
                                            "STUDENT_2026_PT2_Q4",
                                          ),
                                        ),
                                      );
                                    }}
                                    block
                                  >
                                    {ADD}
                                  </Button>
                                </Form.Item>
                              )}
                            </Flex>
                          </Col>
                        </Row>
                        {form.getFieldValue("STUDENT_2026_PT2_Q4").length - 1 >
                          index && <div className="divider"></div>}
                      </Space>
                    );
                  })}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 5. अपने सभी वेदाध्यापक व वेदविद्यालय के नाम जहाँ आपने वेदाध्ययन किया */}
        <Row>
          <Col xs={24} className="onClickRenderFields">
            <Typography.Text>
              {Text({
                tid: "STUDENT_2026_PT2_Q5",
                def: "Ved Teacher And Student Details",
              })}
            </Typography.Text>

            <Form.List name="STUDENT_2026_PT2_Q5">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Space
                      key={key}
                      align="baseline"
                      className="QuestionsSubSection"
                    >
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q5_A"]}
                            label={STUDENT_2026_PT2_Q5_A}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <DatePicker
                              disabled={disabled || isReviewMode}
                              picker="month"
                              format="MM-YYYY"
                              disabledDate={(current) =>
                                current && current > dayjs().endOf("month")
                              }
                              placeholder={SELECT_DATE}
                              style={{ width: "100%" }}
                              onChange={(date, dateString) =>
                                handleDateChange(
                                  form,
                                  "STUDENT_2026_PT2_Q5",
                                  index,
                                  Array.isArray(dateString)
                                    ? dateString[0]
                                    : dateString,
                                  handleFieldChange,
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q5_B"]}
                            label={STUDENT_2026_PT2_Q5_B}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <DatePicker
                              disabled={disabled || isReviewMode}
                              picker="month"
                              format="MM-YYYY"
                              disabledDate={(current) =>
                                current && current > dayjs().endOf("month")
                              }
                              placeholder={SELECT_DATE}
                              style={{ width: "100%" }}
                              onChange={(date, dateString) =>
                                handleDateChange(
                                  form,
                                  "STUDENT_2026_PT2_Q5",
                                  index,
                                  Array.isArray(dateString)
                                    ? dateString[0]
                                    : dateString,
                                  handleFieldChange,
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q5_C"]}
                            label={STUDENT_2026_PT2_Q5_C}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <>
                              <Input
                                disabled={disabled || isReviewMode}
                                placeholder={STUDENT_2026_PT2_Q5_C_PLACEHOLDER}
                              />
                            </>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q5_D"]}
                            label={STUDENT_2026_PT2_Q5_D}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <>
                              <Input
                                disabled={disabled || isReviewMode}
                                placeholder={STUDENT_2026_PT2_Q5_D_PLACEHOLDER}
                              />
                            </>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q5_E"]}
                            label={STUDENT_2026_PT2_Q5_E}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled || isReviewMode}
                              placeholder={STUDENT_2026_PT2_Q5_E_PLACEHOLDER}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "25px" }}>
                        {/* Add Remove Button */}
                        <Col xs={24}>
                          <Flex gap={30}>
                            {form.getFieldValue("STUDENT_2026_PT2_Q5").length >
                              1 && (
                              <Form.Item>
                                <Button
                                  disabled={disabled || isReviewMode}
                                  variant="filled"
                                  className="actionButton"
                                  // onClick={() => remove(name)}
                                  onClick={() => {
                                    if (
                                      form.getFieldValue("STUDENT_2026_PT2_Q5")
                                        .length > 1
                                    ) {
                                      remove(name);
                                    }
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                            )}
                            {form.getFieldValue("STUDENT_2026_PT2_Q5").length -
                              1 ===
                              index && (
                              <Form.Item>
                                <Button
                                  disabled={disabled || isReviewMode}
                                  variant="filled"
                                  className="actionButton"
                                  onClick={() => {
                                    add();
                                  }}
                                  block
                                >
                                  {ADD}
                                </Button>
                              </Form.Item>
                            )}
                          </Flex>
                        </Col>
                      </Row>
                      {form.getFieldValue("STUDENT_2026_PT2_Q5").length - 1 >
                        index && <div className="divider"></div>}
                    </Space>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 6. अधीत वेद ग्रन्थों का विवरण */}
        <Row>
          <Col xs={24} className="onClickRenderFields">
            <Typography.Text>
              {Text({
                tid: "STUDENT_2026_PT2_Q6",
                def: "Ved Studies Details ",
              })}
            </Typography.Text>
            <Typography.Text type="secondary">
              {Text({
                tid: "STUDENT_2026_PT2_Q6_SUBTEXT",
                def: "अधीत वेदशाखा के उन सभी ग्रन्थों का वर्णन कीजिये जिनका अध्ययन कर आप परीक्षा उत्तीर्ण कर चुके हैं। यदि किसी ग्रन्थ का अध्ययन कर रहे हैं, परन्तु परीक्षा शेष है, तो उसका भी उल्लेख कीजिये। अधीत वेदशाखा के अलावा किसी अन्य वेद,शाखा या ग्रन्थ का अध्ययन किया है, तो अन्त में ऐसे सभी ग्रन्थों का विवरण दीजिये।)",
              })}
            </Typography.Text>
            <Form.List name="STUDENT_2026_PT2_Q6">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Space
                      key={key}
                      align="baseline"
                      className="QuestionsSubSection"
                    >
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q6_A"]}
                            label={STUDENT_2026_PT2_Q6_A}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input
                              disabled={disabled || isReviewMode}
                              placeholder={STUDENT_2026_PT2_Q6_A_PLACEHOLDER}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q6_B"]}
                            label={STUDENT_2026_PT2_Q6_B}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <Input.TextArea
                              disabled={disabled || isReviewMode}
                              placeholder={STUDENT_2026_PT2_Q6_B_PLACEHOLDER}
                              maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                              style={{ paddingBottom: 20 }}
                            />
                          </Form.Item>
                          <LengthCounter
                            form={form}
                            fieldName="STUDENT_2026_PT2_Q6_B"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q6_C"]}
                            label={STUDENT_2026_PT2_Q6_C}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <DatePicker
                              disabled={disabled || isReviewMode}
                              picker="month"
                              format="MM-YYYY"
                              disabledDate={(current) =>
                                current && current > dayjs().endOf("month")
                              }
                              placeholder={SELECT_DATE}
                              style={{ width: "100%" }}
                              onChange={(date, dateString) =>
                                handleDateChange(
                                  form,
                                  "STUDENT_2026_PT2_Q6",
                                  index,
                                  Array.isArray(dateString)
                                    ? dateString[0]
                                    : dateString,
                                  handleFieldChange,
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q6_D"]}
                            label={STUDENT_2026_PT2_Q6_D}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <DatePicker
                              disabled={disabled || isReviewMode}
                              picker="month"
                              format="MM-YYYY"
                              disabledDate={(current) =>
                                current && current > dayjs().endOf("month")
                              }
                              placeholder={SELECT_DATE}
                              style={{ width: "100%" }}
                              onChange={(date, dateString) =>
                                handleDateChange(
                                  form,
                                  "STUDENT_2026_PT2_Q6",
                                  index,
                                  Array.isArray(dateString)
                                    ? dateString[0]
                                    : dateString,
                                  handleFieldChange,
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          <Form.Item
                            className="w-full"
                            {...restField}
                            name={[name, "STUDENT_2026_PT2_Q6_E"]}
                            label={STUDENT_2026_PT2_Q6_E}
                            rules={[
                              {
                                required: true,
                                message: REQUIRED,
                              },
                            ]}
                          >
                            <DatePicker
                              disabled={disabled || isReviewMode}
                              picker="month"
                              format="MM-YYYY"
                              disabledDate={(current) =>
                                current && current > dayjs().endOf("month")
                              }
                              placeholder={SELECT_DATE}
                              style={{ width: "100%" }}
                              onChange={(date, dateString) =>
                                handleDateChange(
                                  form,
                                  "STUDENT_2026_PT2_Q6",
                                  index,
                                  Array.isArray(dateString)
                                    ? dateString[0]
                                    : dateString,
                                  handleFieldChange,
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={24} lg={12} xl={8}>
                          {(() => {
                            const docUrl = form.getFieldValue([
                              "STUDENT_2026_PT2_Q6",
                              name,
                              "STUDENT_2026_PT2_Q6_DOC",
                            ]);
                            const currentFieldName = `STUDENT_2026_PT2_Q6_${index}_DOC`;

                            return (
                              <div
                                style={{ paddingLeft: "25px" }}
                                id={currentFieldName}
                              >
                                <DocumentUploadField
                                  formId={formId || ""}
                                  labelStyle={{ paddingLeft: "0px" }}
                                  userId={
                                    currentUserId
                                      ? currentUserId.toString()
                                      : ""
                                  }
                                  label={STUDENT_2026_PT2_Q6_F}
                                  fieldName={currentFieldName}
                                  existingDocuments={
                                    docUrl
                                      ? [
                                          {
                                            labelName: currentFieldName,
                                            docPath: docUrl,
                                          },
                                        ]
                                      : []
                                  }
                                  disabled={disabled || isReviewMode}
                                  onUploadComplete={(docUrl) => {
                                    // Set form value for UI display only
                                    form.setFieldValue(
                                      [
                                        "STUDENT_2026_PT2_Q6",
                                        name,
                                        "STUDENT_2026_PT2_Q6_DOC",
                                      ],
                                      docUrl,
                                    );
                                    // Use patch to inject docUrl directly — avoids setFieldValue race condition
                                    handleFieldChange(
                                      "STUDENT_2026_PT2_Q6",
                                      buildArrayPayload(
                                        form.getFieldValue(
                                          "STUDENT_2026_PT2_Q6",
                                        ),
                                        [],
                                        {
                                          rowIndex: name,
                                          fieldKey: "STUDENT_2026_PT2_Q6_DOC",
                                          value: docUrl,
                                        },
                                      ),
                                    );
                                  }}
                                />
                              </div>
                            );
                          })()}
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "25px" }}>
                        {/* Add Remove Button */}
                        <Col xs={24}>
                          <Flex gap={30}>
                            {form.getFieldValue("STUDENT_2026_PT2_Q6").length >
                              1 && (
                              <Form.Item>
                                <Button
                                  disabled={disabled || isReviewMode}
                                  variant="filled"
                                  className="actionButton"
                                  onClick={() => {
                                    if (
                                      form.getFieldValue("STUDENT_2026_PT2_Q6")
                                        .length > 1
                                    ) {
                                      remove(name);
                                      // setTimeout(0) lets Ant Design flush the removal before we read form state
                                      setTimeout(() => {
                                        handleFieldChange(
                                          "STUDENT_2026_PT2_Q6",
                                          buildArrayPayload(
                                            form.getFieldValue(
                                              "STUDENT_2026_PT2_Q6",
                                            ),
                                          ),
                                        );
                                      }, 0);
                                    }
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                            )}

                            {form.getFieldValue("STUDENT_2026_PT2_Q6").length -
                              1 ===
                              index && (
                              <Form.Item>
                                <Button
                                  disabled={disabled || isReviewMode}
                                  variant="filled"
                                  className="actionButton"
                                  onClick={() => {
                                    add();
                                    handleFieldChange(
                                      "STUDENT_2026_PT2_Q6",
                                      buildArrayPayload(
                                        form.getFieldValue(
                                          "STUDENT_2026_PT2_Q6",
                                        ),
                                      ),
                                    );
                                  }}
                                  block
                                >
                                  {ADD}
                                </Button>
                              </Form.Item>
                            )}
                          </Flex>
                        </Col>
                      </Row>
                      {form.getFieldValue("STUDENT_2026_PT2_Q6").length - 1 >
                        index && <div className="divider"></div>}
                    </Space>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 7. Awards */}
        <Row>
          <Col xs={24} className="onClickRenderFields">
            <Form.Item
              name="STUDENT_2026_PT2_Q7_CONFIRMATION"
              label={Text({
                tid: "STUDENT_2026_PT2_Q7_CONFIRMATION",
                def: "",
              })}
              rules={[{ required: true, message: REQUIRED }]}
            >
              <Radio.Group
                disabled={disabled || isReviewMode}
                onChange={(e) => {
                  handleFieldChange(
                    "STUDENT_2026_PT2_Q7_CONFIRMATION",
                    e.target.value,
                  );
                  if (e.target.value === "YES") {
                    const q7Value = form.getFieldValue("STUDENT_2026_PT2_Q7");
                    if (!Array.isArray(q7Value) || q7Value.length === 0) {
                      form.setFieldValue("STUDENT_2026_PT2_Q7", [{}]);
                    }
                  }
                }}
              >
                <Radio value="YES">{YES}</Radio>
                <Radio value="NO">{NO}</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={(prev, current) =>
                prev.STUDENT_2026_PT2_Q7_CONFIRMATION !==
                  current.STUDENT_2026_PT2_Q7_CONFIRMATION ||
                prev.STUDENT_2026_PT2_Q7 !== current.STUDENT_2026_PT2_Q7
              }
            >
              {({ getFieldValue }) =>
                getFieldValue("STUDENT_2026_PT2_Q7_CONFIRMATION") === "YES" ? (
                  <>
                    <Typography.Text>{STUDENT_2026_PT2_Q7}</Typography.Text>
                    <Form.List name="STUDENT_2026_PT2_Q7" initialValue={[{}]}>
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }, index) => (
                            <Space
                              key={key}
                              align="baseline"
                              className="QuestionsSubSection"
                            >
                              <Row>
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q7_A"]}
                                    label={STUDENT_2026_PT2_Q7_A}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      disabled={disabled || isReviewMode}
                                      picker="month"
                                      format="MM-YYYY"
                                      disabledDate={(current) =>
                                        current &&
                                        current > dayjs().endOf("month")
                                      }
                                      placeholder={SELECT_DATE}
                                      style={{ width: "100%" }}
                                      onChange={(date, dateString) =>
                                        handleDateChange(
                                          form,
                                          "STUDENT_2026_PT2_Q7",
                                          index,
                                          Array.isArray(dateString)
                                            ? dateString[0]
                                            : dateString,
                                          handleFieldChange,
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q7_B"]}
                                    label={STUDENT_2026_PT2_Q7_B}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <Input
                                      disabled={disabled || isReviewMode}
                                      placeholder={
                                        STUDENT_2026_PT2_Q7_B_PLACEHOLDER
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q7_C"]}
                                    label={STUDENT_2026_PT2_Q7_C}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <Input
                                      disabled={disabled || isReviewMode}
                                      placeholder={
                                        STUDENT_2026_PT2_Q7_C_PLACEHOLDER
                                      }
                                      id={
                                        applyPdfStyles ? "affidavit_input" : ""
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={24} lg={12} xl={8}>
                                  {(() => {
                                    const docUrl = form.getFieldValue([
                                      "STUDENT_2026_PT2_Q7",
                                      name,
                                      "STUDENT_2026_PT2_Q7_DOC",
                                    ]);
                                    const currentFieldName = `STUDENT_2026_PT2_Q7_${index}_DOC`;

                                    return (
                                      <div
                                        style={{ paddingLeft: "25px" }}
                                        id={currentFieldName}
                                      >
                                        <DocumentUploadField
                                          formId={formId || ""}
                                          labelStyle={{ paddingLeft: "0px" }}
                                          userId={
                                            currentUserId
                                              ? currentUserId.toString()
                                              : ""
                                          }
                                          label={STUDENT_2026_PT2_Q7_D}
                                          fieldName={currentFieldName}
                                          existingDocuments={
                                            docUrl
                                              ? [
                                                  {
                                                    labelName: currentFieldName,
                                                    docPath: docUrl,
                                                  },
                                                ]
                                              : []
                                          }
                                          disabled={disabled || isReviewMode}
                                          onUploadComplete={(docUrl) => {
                                            // Set form value for UI display only
                                            form.setFieldValue(
                                              [
                                                "STUDENT_2026_PT2_Q7",
                                                name,
                                                "STUDENT_2026_PT2_Q7_DOC",
                                              ],
                                              docUrl,
                                            );
                                            // Use patch to inject docUrl directly — avoids setFieldValue race condition
                                            handleFieldChange(
                                              "STUDENT_2026_PT2_Q7",
                                              buildArrayPayload(
                                                form.getFieldValue(
                                                  "STUDENT_2026_PT2_Q7",
                                                ),
                                                [],
                                                {
                                                  rowIndex: name,
                                                  fieldKey:
                                                    "STUDENT_2026_PT2_Q7_DOC",
                                                  value: docUrl,
                                                },
                                              ),
                                            );
                                          }}
                                        />
                                      </div>
                                    );
                                  })()}
                                </Col>
                              </Row>
                              <Row style={{ marginTop: "25px" }}>
                                {/* Add Remove Button */}
                                <Col xs={24}>
                                  <Flex gap={30}>
                                    {form.getFieldValue("STUDENT_2026_PT2_Q7")
                                      .length > 1 && (
                                      <Form.Item>
                                        <Button
                                          disabled={disabled || isReviewMode}
                                          variant="filled"
                                          className="actionButton"
                                          onClick={() => {
                                            if (
                                              form.getFieldValue(
                                                "STUDENT_2026_PT2_Q7",
                                              ).length > 1
                                            ) {
                                              remove(name);
                                              // setTimeout(0) lets Ant Design flush the removal before we read form state
                                              setTimeout(() => {
                                                handleFieldChange(
                                                  "STUDENT_2026_PT2_Q7",
                                                  buildArrayPayload(
                                                    form.getFieldValue(
                                                      "STUDENT_2026_PT2_Q7",
                                                    ),
                                                  ),
                                                );
                                              }, 0);
                                            }
                                          }}
                                        >
                                          {REMOVE}
                                        </Button>
                                      </Form.Item>
                                    )}

                                    {form.getFieldValue("STUDENT_2026_PT2_Q7")
                                      .length -
                                      1 ===
                                      index && (
                                      <Form.Item>
                                        <Button
                                          disabled={disabled || isReviewMode}
                                          variant="filled"
                                          className="actionButton"
                                          onClick={() => {
                                            add();
                                            handleFieldChange(
                                              "STUDENT_2026_PT2_Q7",
                                              buildArrayPayload(
                                                form.getFieldValue(
                                                  "STUDENT_2026_PT2_Q7",
                                                ),
                                              ),
                                            );
                                          }}
                                          block
                                        >
                                          {ADD}
                                        </Button>
                                      </Form.Item>
                                    )}
                                  </Flex>
                                </Col>
                              </Row>
                              {form.getFieldValue("STUDENT_2026_PT2_Q7")
                                .length -
                                1 >
                                index && <div className="divider"></div>}
                            </Space>
                          ))}
                        </>
                      )}
                    </Form.List>
                  </>
                ) : null
              }
            </Form.Item>
          </Col>
        </Row>
        {/* 8. Other Vedic Activities */}
        <Row>
          <Col xs={24} className="onClickRenderFields">
            <Form.Item
              name="STUDENT_2026_PT2_Q8_CONFIRMATION"
              label={Text({
                tid: "STUDENT_2026_PT2_Q8_CONFIRMATION",
                def: "",
              })}
              rules={[{ required: true, message: REQUIRED }]}
            >
              <Radio.Group
                disabled={disabled || isReviewMode}
                onChange={(e) => {
                  handleFieldChange(
                    "STUDENT_2026_PT2_Q8_CONFIRMATION",
                    e.target.value,
                  );

                  if (e.target.value === "YES") {
                    const q8Value = form.getFieldValue("STUDENT_2026_PT2_Q8");
                    if (!Array.isArray(q8Value) || q8Value.length === 0) {
                      form.setFieldValue("STUDENT_2026_PT2_Q8", [{}]);
                    }
                  }
                }}
              >
                <Radio value="YES">{YES}</Radio>
                <Radio value="NO">{NO}</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={(prev, current) =>
                prev.STUDENT_2026_PT2_Q8_CONFIRMATION !==
                  current.STUDENT_2026_PT2_Q8_CONFIRMATION ||
                prev.STUDENT_2026_PT2_Q8 !== current.STUDENT_2026_PT2_Q8
              }
            >
              {({ getFieldValue }) =>
                getFieldValue("STUDENT_2026_PT2_Q8_CONFIRMATION") === "YES" ? (
                  <Space>
                    <Typography.Text>{STUDENT_2026_PT2_Q8}</Typography.Text>
                    <Form.List name="STUDENT_2026_PT2_Q8" initialValue={[{}]}>
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }, index) => (
                            <Space
                              key={key}
                              align="baseline"
                              className="QuestionsSubSection"
                            >
                              <Row>
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q8_A"]}
                                    label={STUDENT_2026_PT2_Q8_A}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <Input
                                      disabled={disabled || isReviewMode}
                                      placeholder={
                                        STUDENT_2026_PT2_Q8_A_PLACEHOLDER
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q8_B"]}
                                    label={STUDENT_2026_PT2_Q8_B}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <Input
                                      disabled={disabled || isReviewMode}
                                      placeholder={
                                        STUDENT_2026_PT2_Q8_B_PLACEHOLDER
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q8_C"]}
                                    label={STUDENT_2026_PT2_Q8_C}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <Input
                                      disabled={disabled || isReviewMode}
                                      placeholder={
                                        STUDENT_2026_PT2_Q8_C_PLACEHOLDER
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={24} lg={12} xl={8}>
                                  <Form.Item
                                    className="w-full"
                                    {...restField}
                                    name={[name, "STUDENT_2026_PT2_Q8_D"]}
                                    label={STUDENT_2026_PT2_Q8_D}
                                    rules={[
                                      {
                                        required: true,
                                        message: REQUIRED,
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      disabled={disabled || isReviewMode}
                                      picker="month"
                                      format="MM-YYYY"
                                      disabledDate={(current) =>
                                        current &&
                                        current > dayjs().endOf("month")
                                      }
                                      placeholder={SELECT_DATE}
                                      style={{ width: "100%" }}
                                      onChange={(date, dateString) =>
                                        handleDateChange(
                                          form,
                                          "STUDENT_2026_PT2_Q8",
                                          index,
                                          Array.isArray(dateString)
                                            ? dateString[0]
                                            : dateString,
                                          handleFieldChange,
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row style={{ marginTop: "25px" }}>
                                {/* Add Remove Button */}
                                <Col xs={24}>
                                  <Flex gap={30}>
                                    {form.getFieldValue("STUDENT_2026_PT2_Q8")
                                      .length > 1 && (
                                      <Form.Item>
                                        <Button
                                          disabled={disabled || isReviewMode}
                                          variant="filled"
                                          className="actionButton"
                                          onClick={() => {
                                            if (
                                              form.getFieldValue(
                                                "STUDENT_2026_PT2_Q8",
                                              ).length > 1
                                            ) {
                                              remove(name);
                                              // setTimeout(0) lets Ant Design flush the removal before we read form state
                                              setTimeout(() => {
                                                handleFieldChange(
                                                  "STUDENT_2026_PT2_Q8",
                                                  buildArrayPayload(
                                                    form.getFieldValue(
                                                      "STUDENT_2026_PT2_Q8",
                                                    ),
                                                  ),
                                                );
                                              }, 0);
                                            }
                                          }}
                                        >
                                          {REMOVE}
                                        </Button>
                                      </Form.Item>
                                    )}

                                    {form.getFieldValue("STUDENT_2026_PT2_Q8")
                                      .length -
                                      1 ===
                                      index && (
                                      <Form.Item>
                                        <Button
                                          disabled={disabled || isReviewMode}
                                          variant="filled"
                                          className="actionButton"
                                          onClick={() => {
                                            add();
                                            handleFieldChange(
                                              "STUDENT_2026_PT2_Q8",
                                              buildArrayPayload(
                                                form.getFieldValue(
                                                  "STUDENT_2026_PT2_Q8",
                                                ),
                                              ),
                                            );
                                          }}
                                          block
                                        >
                                          {ADD}
                                        </Button>
                                      </Form.Item>
                                    )}
                                  </Flex>
                                </Col>
                              </Row>
                              {form.getFieldValue("STUDENT_2026_PT2_Q8")
                                .length -
                                1 >
                                index && <div className="divider"></div>}
                            </Space>
                          ))}
                        </>
                      )}
                    </Form.List>
                  </Space>
                ) : null
              }
            </Form.Item>
          </Col>
        </Row>
        {/* 9. Passport Size Photo */}
        <Row>
          <Col xs={24} lg={12} xl={8}>
            <DocumentUploadField
              fieldName="STUDENT_2026_PT2_Q9"
              label={Text({
                tid: "STUDENT_2026_PT2_Q9",
                def: "9. Passport Size Photo",
              })}
              formId={formId || ""}
              userId={user?.id || ""}
              currentStage={eFORMSTATUS.STAGE2INPROGRESS}
              disabled={disabled || isReviewMode}
              existingDocuments={documentsData}
              onUploadComplete={(docId) =>
                handleFieldChange(
                  "STUDENT_2026_PT2_Q9",
                  docId,
                  eAnswerType.FILE,
                )
              }
            />
          </Col>
        </Row>

        {/* DOCUMENT SUMMARY TABLE */}
        <div style={{ marginTop: "24px" }}>
          <Row>
            <Col xs={24}>
              <Typography.Text strong>
                {Text({
                  tid: "ATTACHED_DOCUMENTS_SUMMARY",
                  def: "Summary of Attached Documents",
                })}
              </Typography.Text>
            </Col>
          </Row>
          <Row style={{ marginTop: "12px" }}>
            <Col xs={24} md={24} lg={24}>
              <Form.Item name="STUDENT_ATTACHED_DOCS_SUMMARY">
                <Table
                  dataSource={
                    form.getFieldValue("STUDENT_ATTACHED_DOCS_SUMMARY") || []
                  }
                  columns={TABLE_COLUMNS_STUDENT_DOC_SUMMARY}
                  pagination={false}
                  locale={{ emptyText: "No documents attached" }}
                  bordered
                  rowKey={(_, index) =>
                    index?.toString() || Math.random().toString()
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        {/* AFFIDAVIT TITLE */}
        <div id="st_form2_applicant_affidavit" className="affidavitSection">
          <Row>
            <Col>
              <Typography.Text>
                {Text({
                  tid: "AFFIDAVIT_TITLE",
                  def: "Affidavit",
                })}
              </Typography.Text>
            </Col>
          </Row>
          <Row className="affidavitRow">
            <Col xs={24}>
              <Typography.Text
                type="secondary"
                style={{
                  maxWidth: "max-content",
                }}
              >
                {Text({
                  tid: "AAVEDAK_AFFIDAVIT_INTRO_11",
                  def: "मैं (आवेदक का पूरा नाम)",
                })}
              </Typography.Text>
              <Form.Item
                name="STUDENT_2026_PT2_Q10"
                className="affidavitRowInput"
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  disabled={true}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
              <Typography.Text
                type="secondary"
                style={{ maxWidth: "max-content", marginBottom: "0" }}
              >
                {Text({
                  tid: "AAVEDAK_AFFIDAVIT_INTRO_12",
                  def: "एतद्द्वारा सत्यनिष्ठा से यह प्रमाणित करता हूँ कि:",
                })}
              </Typography.Text>
            </Col>
          </Row>
          {/* AFFIDAVIT DESCRIPTION */}
          <Row>
            <Col>
              <ul>
                <li>
                  <Typography.Text type="secondary">
                    {Text({
                      tid: "AFFIDAVIT_CLAUSE_1",
                      def: "AFFIDAVIT_CLAUSE_1",
                    })}
                  </Typography.Text>
                </li>

                <li>
                  <Typography.Text type="secondary">
                    {Text({
                      tid: "AFFIDAVIT_CLAUSE_2",
                      def: "AFFIDAVIT_CLAUSE_2",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text type="secondary">
                    {Text({
                      tid: "AFFIDAVIT_CLAUSE_3",
                      def: "AFFIDAVIT_CLAUSE_3",
                    })}
                  </Typography.Text>
                </li>
              </ul>
              <div>
                <Typography.Text type="secondary">
                  {Text({
                    tid: "AFFIDAVIT_VERIFICATION",
                    def: "AFFIDAVIT_VERIFICATION",
                  })}
                </Typography.Text>
                <Typography.Text type="secondary">
                  {Text({
                    tid: "AFFIDAVIT_UNDERSTANDING",
                    def: "AFFIDAVIT_UNDERSTANDING",
                  })}
                </Typography.Text>
                {!disabled ? (
                  <Form.Item
                    name="affidavitAccepted"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        transform: (value: boolean) => value || undefined,
                        type: "boolean",
                        message: Text({
                          tid: "AFFIDAVIT_ACCEPTANCE_REQUIRED",
                          def: "You must accept the affidavit declaration to submit the form",
                        }),
                      },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <Checkbox
                      checked={affidavitAccepted}
                      disabled={disabled || isReviewMode}
                    >
                      {Text({
                        tid: "AFFIDAVIT_ACCEPTANCE",
                        def: "AFFIDAVIT_ACCEPTANCE",
                      })}
                    </Checkbox>
                  </Form.Item>
                ) : (
                  <Typography.Text type="secondary">
                    {Text({
                      tid: "AFFIDAVIT_ACCEPTANCE",
                      def: "AFFIDAVIT_ACCEPTANCE",
                    })}
                  </Typography.Text>
                )}
              </div>
            </Col>
          </Row>
          {/* AFFIDAVIT QUESTION */}
          <Row className="QuestionsSubSection affidavitQuestionFirst">
            <Col xs={24} lg={12} xl={8}>
              <Form.Item
                name="STUDENT_2026_PT2_Q11"
                label={Text({
                  tid: "FULL_NAME_OF_APPLICANT",
                  def: "FULL_NAME_OF_APPLICANT",
                })}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  disabled={true}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="QuestionsSubSection">
            <Col xs={24} lg={12} xl={8}>
              <Form.Item
                name="STUDENT_2026_PT2_Q12"
                label={Text({ tid: "PLACE", def: "PLACE" })}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  disabled={disabled || isReviewMode}
                  placeholder={PLACE_PLACEHOLDER}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="QuestionsSubSection">
            <Col xs={24} lg={12} xl={8}>
              <Form.Item
                name="STUDENT_2026_PT2_Q13"
                label={Text({ tid: "DATE", def: "DATE" })}
                initialValue={dayjs()}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <DatePicker
                  disabled={disabled || isReviewMode}
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  placeholder="DD-MM-YYYY"
                  defaultValue={dayjs()}
                  onChange={(date) => {
                    // We store the ISO string or whatever format backend expects
                    // but usually DatePicker returns a Dayjs object in onChange's first arg
                    // Here we can rely on standard form behavior or force string
                    if (date) {
                      handleFieldChange(
                        "STUDENT_2026_PT2_Q13",
                        date,
                        eAnswerType.DATE,
                      );
                    }
                  }}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="affidavitSection" style={{ marginBottom: "25px" }}>
          <Row className=" QuestionsSubSection">
            <Col xs={24} lg={12} xl={8}>
              <DocumentUploadField
                fieldName="STUDENT_2026_PT2_Q14"
                label={Text({
                  tid: "SIGNATURE_OF_APPLICANT",
                  def: "Upload signature",
                })}
                formId={formId || ""}
                userId={user?.id || ""}
                currentStage={eFORMSTATUS.STAGE2INPROGRESS}
                disabled={disabled || isReviewMode}
                existingDocuments={documentsData}
                onUploadComplete={(docId) =>
                  handleFieldChange(
                    "STUDENT_2026_PT2_Q14",
                    docId,
                    eAnswerType.FILE,
                  )
                }
              />
            </Col>
          </Row>
        </div>
        {/* Q15 - Download buttons for teacher affidavit and praptra */}
        {!disabled && (
          <div className="affidavitSection">
            <Row>
              <Col xs={24}>
                <Typography.Text type="secondary">
                  {Text({
                    tid: "STUDENT_2026_PT2_Q15_DOWNLOAD_HEADING",
                    def: "Information provided by your current Veda teacher: (Download this form, print it, get it filled by your current teacher, and upload it.)",
                  })}
                </Typography.Text>
              </Col>
            </Row>
            <Row className="mb-15 QuestionsSubSection">
              <Space wrap>
                <Button
                  type="default"
                  onClick={() =>
                    handleGeneratePDF(
                      "st_form2_guru_affidavit",
                      "student_form2_guru_affidavit",
                    )
                  }
                  className="downloadAffidavitButton"
                >
                  {Text({
                    tid: "DOWNLOAD_TEACHER_AFFIDAVIT",
                    def: "Download Teacher's Affidavit",
                  })}
                </Button>
                <Button
                  type="default"
                  onClick={() =>
                    handleGeneratePDF(
                      "st_form2_guru_praptra",
                      "student_form2_guru_praptra",
                    )
                  }
                  className="downloadAffidavitButton"
                >
                  {Text({
                    tid: "DOWNLOAD_PRAPTRA",
                    def: "Download Praptra",
                  })}
                </Button>
              </Space>
            </Row>
          </div>
        )}

        <div
          id="st_form2_guru_affidavit"
          className="affidavitSection"
          style={{ display: applyPdfStyles ? "block" : "none" }}
        >
          <Row style={{ marginBottom: "5px" }}>
            <Col>
              <Typography.Text>
                {Text({
                  tid: "GURU_AFFIDAVIT_TITLE",
                  def: "Affidavit",
                })}
              </Typography.Text>
            </Col>
          </Row>
          {/* GURU AFFIDAVIT INTRO */}
          <Row className="affidavitRow">
            <Col xs={24}>
              <Typography.Text type="secondary">
                {Text({
                  tid: "GURU_AFFIDAVIT_INTRO_11",
                  def: "GURU_AFFIDAVIT_INTRO_11",
                })}
              </Typography.Text>
              <Form.Item
                name="STUDENT_PT2_Q20"
                style={{ maxWidth: "200px" }}
                className="affidavitRowInput"
              >
                <Input
                  disabled={disabled || isReviewMode}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
              <Typography.Text type="secondary">
                {Text({
                  tid: "GURU_AFFIDAVIT_INTRO_12",
                  def: "GURU_AFFIDAVIT_INTRO_12",
                })}
              </Typography.Text>
              <Form.Item
                name="STUDENT_PT2_Q21"
                style={{ maxWidth: "200px" }}
                className="affidavitRowInput"
              >
                <Input
                  disabled={disabled || isReviewMode}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
              <Typography.Text type="secondary">
                {Text({
                  tid: "GURU_AFFIDAVIT_INTRO_13",
                  def: "GURU_AFFIDAVIT_INTRO_13",
                })}
              </Typography.Text>
            </Col>
          </Row>
          {/* GURU AFFIDAVIT DESCRIPTION */}
          <Row>
            <Col>
              <ul>
                <li>
                  <Typography.Text type="secondary">
                    {Text({
                      tid: "GURU_AFFIDAVIT_CLAUSES_1",
                      def: "GURU_AFFIDAVIT_CLAUSES_1",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <Typography.Text type="secondary">
                    {Text({
                      tid: "GURU_AFFIDAVIT_CLAUSES_2",
                      def: "GURU_AFFIDAVIT_CLAUSES_2",
                    })}
                  </Typography.Text>
                </li>
              </ul>
              <div>
                <Typography.Text type="secondary">
                  {Text({
                    tid: "GURU_AFFIDAVIT_VERIFICATION",
                    def: "GURU_AFFIDAVIT_VERIFICATION",
                  })}
                </Typography.Text>
                <Typography.Text type="secondary">
                  {Text({
                    tid: "GURU_AFFIDAVIT_ACCEPTANCE",
                    def: "GURU_AFFIDAVIT_ACCEPTANCE",
                  })}
                </Typography.Text>
              </div>
            </Col>
          </Row>

          {/* NAME */}
          <Row className="QuestionsSubSection affidavitQuestionFirst">
            <Col xs={24} lg={12} xl={8}>
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({ tid: "GURU_FULL_NAME", def: "GURU_FULL_NAME" })}
                  </span>
                  <Form.Item
                    name="STUDENT_PT2_Q23"
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={disabled || isReviewMode}
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name="STUDENT_PT2_Q23"
                  label={Text({ tid: "GURU_FULL_NAME", def: "GURU_FULL_NAME" })}
                >
                  <Input
                    disabled={disabled || isReviewMode}
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          {/* LOCATION */}
          <Row className="QuestionsSubSection">
            <Col xs={24} lg={12} xl={8}>
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({ tid: "GURU_LOCATION", def: "GURU_LOCATION" })}
                  </span>
                  <Form.Item
                    name="STUDENT_PT2_Q24"
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={disabled || isReviewMode}
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name="STUDENT_PT2_Q24"
                  label={Text({ tid: "GURU_LOCATION", def: "GURU_LOCATION" })}
                >
                  <Input
                    disabled={disabled || isReviewMode}
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          {/* DATE */}
          <Row className="QuestionsSubSection">
            <Col xs={24} lg={12} xl={8}>
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({ tid: "GURU_DATE", def: "GURU_DATE" })}
                  </span>
                  <Form.Item
                    name="STUDENT_PT2_Q25"
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={disabled || isReviewMode}
                      type={applyPdfStyles ? undefined : "date"}
                      max={disableFutureDates_on_input_date_max()}
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name="STUDENT_PT2_Q25"
                  label={Text({ tid: "GURU_DATE", def: "GURU_DATE" })}
                >
                  <Input
                    disabled={disabled || isReviewMode}
                    type={applyPdfStyles ? undefined : "date"}
                    max={disableFutureDates_on_input_date_max()}
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {applyPdfStyles ? (
            <Row className="QuestionsSubSection">
              <Col xs={24} lg={12} xl={8}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "SIGNATURE_OF_VEDA_TEACHER",
                      def: "Signature of Veda Teacher",
                    })}
                  </span>
                  <Form.Item style={{ marginBottom: 0, flex: 1 }}>
                    <Input id={applyPdfStyles ? "affidavit_input" : ""} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          ) : null}
        </div>

        {/* GURU PRAPTRA (INFORMATION FORM) - Hidden, rendered as PDF */}
        <div
          id="st_form2_guru_praptra"
          className="affidavitSection"
          style={{
            display: applyPdfStyles ? "block" : "none",
            fontSize: "13px",
          }}
        >
          {/* PRAPTRA TITLE */}
          <Row style={{ marginBottom: "4px" }}>
            <Col>
              <Typography.Text style={{ fontWeight: 600 }}>
                {Text({
                  tid: "PRAPTRA_TITLE",
                  def: "प्रपत्र - वेदाध्यापक द्वारा भरा जाने वाला",
                })}
              </Typography.Text>
            </Col>
          </Row>

          {/* TEACHER NAME */}
          <Row style={{ marginBottom: "4px" }}>
            <Col xs={24}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Typography.Text
                  type="secondary"
                  style={{ minWidth: "max-content", fontSize: "13px" }}
                >
                  {Text({
                    tid: "PRAPTRA_TEACHER_NAME",
                    def: "वेदाध्यापक का नाम :",
                  })}
                </Typography.Text>
                <Form.Item
                  name="STUDENT_PT2_Q15"
                  style={{ marginBottom: 0, flex: 1 }}
                >
                  <Input
                    disabled={disabled || isReviewMode}
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>

          {/* TEACHER QUALIFICATION */}
          <Row style={{ marginBottom: "2px" }}>
            <Col xs={24}>
              <Typography.Text type="secondary" style={{ fontSize: "13px" }}>
                {Text({
                  tid: "PRAPTRA_TEACHER_QUALIFICATION",
                  def: "वेदाध्यापक का उच्चतम शिक्षास्तर :",
                })}
              </Typography.Text>
              <Form.Item
                name="STUDENT_PT2_Q16"
                style={{ marginBottom: 0, marginTop: 2 }}
              >
                <Input
                  disabled={disabled || isReviewMode}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* APPLICANT CONDUCT */}
          <Row style={{ marginBottom: "2px" }}>
            <Col xs={24}>
              <Typography.Text type="secondary" style={{ fontSize: "13px" }}>
                {Text({
                  tid: "PRAPTRA_APPLICANT_CONDUCT",
                  def: "क्या आवेदक का आचरण वेदानुकूल रहा है? अपनी टिप्पणी दीजिये।",
                })}
              </Typography.Text>
              <Form.Item
                name="STUDENT_PT2_PRAPTRA_CONDUCT"
                style={{ marginBottom: 0, marginTop: 2 }}
              >
                <Input
                  disabled={disabled || isReviewMode}
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* RECITATION QUESTION */}
          <Row style={{ marginBottom: "4px", marginTop: "4px" }}>
            <Col xs={24}>
              <Typography.Text type="secondary" style={{ fontSize: "13px" }}>
                {Text({
                  tid: "PRAPTRA_RECITATION_QUESTION",
                  def: "आवेदक ने जिस-जिस स्तर की परीक्षा उत्तीर्ण की हैं...",
                })}
              </Typography.Text>
            </Col>
          </Row>

          {/* RECITATION LEVELS TABLE */}
          <Row>
            <Col xs={24}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <tbody>
                  {/* Mool Patha */}
                  <tr>
                    <td style={{ padding: "3px 4px", verticalAlign: "middle" }}>
                      <Typography.Text type="secondary">
                        {Text({ tid: "PRAPTRA_MULPATHA", def: "मूल पाठ :" })}
                        &nbsp;&nbsp;
                        {Text({ tid: "PRAPTRA_YES", def: "☐ हाँ" })}
                        &nbsp;&nbsp;&nbsp;
                        {Text({ tid: "PRAPTRA_NO", def: "☐ नहीं" })}
                      </Typography.Text>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  {/* Prakriti Patha */}
                  <tr>
                    <td style={{ padding: "3px 4px", verticalAlign: "middle" }}>
                      <Typography.Text type="secondary">
                        {Text({
                          tid: "PRAPTRA_PRAKRITI_PATHA",
                          def: "प्रकृति पाठ :",
                        })}
                        &nbsp;&nbsp;
                        {Text({ tid: "PRAPTRA_YES", def: "☐ हाँ" })}
                        &nbsp;&nbsp;&nbsp;
                        {Text({ tid: "PRAPTRA_NO", def: "☐ नहीं" })}
                      </Typography.Text>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  {/* Level 1 */}
                  <tr>
                    <td style={{ padding: "3px 4px", verticalAlign: "middle" }}>
                      <Typography.Text type="secondary">
                        {Text({
                          tid: "PRAPTRA_LEVEL_1_PATHA",
                          def: "स्तर-१ के पाठ :",
                        })}
                        &nbsp;&nbsp;
                        {Text({ tid: "PRAPTRA_YES", def: "☐ हाँ" })}
                        &nbsp;&nbsp;&nbsp;
                        {Text({ tid: "PRAPTRA_NO", def: "☐ नहीं" })}
                      </Typography.Text>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  {/* Level 2 */}
                  <tr>
                    <td style={{ padding: "3px 4px", verticalAlign: "middle" }}>
                      <Typography.Text type="secondary">
                        {Text({
                          tid: "PRAPTRA_LEVEL_2_PATHA",
                          def: "स्तर-२ के पाठ :",
                        })}
                        &nbsp;&nbsp;
                        {Text({ tid: "PRAPTRA_YES", def: "☐ हाँ" })}
                        &nbsp;&nbsp;&nbsp;
                        {Text({ tid: "PRAPTRA_NO", def: "☐ नहीं" })}
                      </Typography.Text>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                  <tr>
                    <td
                      style={{ borderTop: "1px solid #999", height: "25px" }}
                    />
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>

          {/* TEACHER SIGNATURE */}
          {applyPdfStyles ? (
            <Row style={{ marginTop: "8px" }}>
              <Col xs={24} lg={12} xl={8}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ minWidth: "max-content", fontSize: "13px" }}>
                    {Text({
                      tid: "PRAPTRA_TEACHER_SIGNATURE",
                      def: "वेदाध्यापक के हस्ताक्षर :",
                    })}
                  </span>
                  <Form.Item style={{ marginBottom: 0, flex: 1 }}>
                    <Input id={applyPdfStyles ? "affidavit_input" : ""} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          ) : null}
        </div>

        {/* GURU AFFIDAVIT SIGNATURE */}

        <Row className=" QuestionsSubSection">
          <Col xs={24} lg={12} xl={8}>
            <DocumentUploadField
              fieldName="STUDENT_2026_PT2_Q15"
              label={Text({
                tid: "STUDENT_2026_PT2_Q15_UPLOAD",
                def: "10. Upload Teacher's Affidavit",
              })}
              labelStyle={{ paddingLeft: "0" }}
              formId={formId || ""}
              userId={user?.id || ""}
              currentStage={eFORMSTATUS.STAGE2INPROGRESS}
              disabled={disabled || isReviewMode}
              existingDocuments={documentsData}
              onUploadComplete={(docId) =>
                handleFieldChange(
                  "STUDENT_2026_PT2_Q15",
                  docId,
                  eAnswerType.FILE,
                )
              }
            />
          </Col>
        </Row>
        <Row className=" QuestionsSubSection">
          <Col xs={24} lg={12} xl={8}>
            <DocumentUploadField
              fieldName="STUDENT_2026_PT2_Q16"
              label={Text({
                tid: "STUDENT_2026_PT2_Q16_UPLOAD",
                def: "11. Upload Teacher's Praptra",
              })}
              labelStyle={{ paddingLeft: "0" }}
              formId={formId || ""}
              userId={user?.id || ""}
              currentStage={eFORMSTATUS.STAGE2INPROGRESS}
              disabled={disabled || isReviewMode}
              existingDocuments={documentsData}
              onUploadComplete={(docId) =>
                handleFieldChange(
                  "STUDENT_2026_PT2_Q16",
                  docId,
                  eAnswerType.FILE,
                )
              }
            />
          </Col>
        </Row>

        <Row
          style={
            disabled === true
              ? { marginTop: "var(--bs-item-negative-margin-30)" }
              : undefined
          }
        >
          {disabled === false && !isReviewMode && (
            <Button
              block
              type="primary"
              onClick={handleNextClick}
              disabled={isLoading || !affidavitAccepted}
              className="formSubmitButton"
            >
              {Text({ tid: "NEXT", def: "Next" })}
            </Button>
          )}
          {disabled === false && isReviewMode && (
            <div style={{ display: "flex", gap: "16px", width: "100%" }}>
              <Button
                block
                onClick={handleBackClick}
                disabled={isLoading}
                className="formSubmitButton"
              >
                {Text({ tid: "BACK", def: "Back" })}
              </Button>
              <Button
                block
                type="primary"
                htmlType="submit"
                disabled={isLoading || !affidavitAccepted}
                className="formSubmitButton"
                loading={isSubmitting}
              >
                {Text({ tid: "SUBMIT", def: "Submit" })}
              </Button>
            </div>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default StudentPartTwo;
